const en = {
    common: {
        url: 'Url',
        or: 'or',
        date: {
            start: 'Starts',
            end: 'Ends',
            format: 'MMM Do',
            type: 'MM-DD-YYYY h:mm A',
            formatInput: 'MM/dd/yyyy',
            formatField: 'MM-DD-YYYY h:mm A',
            formatView: 'LL',
        },
        hour: {
            format: 'h:mm A',
        },
        add: 'Add',
        cancel: 'Cancel',
        reset: 'Reset',
        manage: 'Manage',
        save: 'Save',
        search: 'Search',
        edit: 'Edit',
        remove: 'Remove',
        new: 'New',
        current: 'Current',
        export: 'Export to Excel',
        noDataToExport: 'No data to export',
        import: 'Import',
        discard: 'Discard',
        yes: 'Yes',
        no: 'No',
        pause: 'Pause',
        areYouSure: 'Are you sure?',
        view: 'View',
        destroy: 'Delete',
        mustSelectARow: 'Must select a row',
        confirm: 'Confirm',
        back: {
            default: 'Back',
            admin: 'Back to Superadmin',
            property: 'Back to Property Manager',
        },
        create: 'Create',
        update: 'Update',
        next: 'Next',
        backButton: 'Back',
        none: 'None',
        overview: 'Overview',
        seeAll: 'See all',
        addEmail: 'Add Email',
        continue: 'Continue',
        apply: 'Register',
        unknownError: 'Unknown error, please try again later or contact support',
        provided: 'Provided',
        download: 'Download',
        downloadButton: {
            ios: {
                availableOn: 'Available on',
                nameStore: 'App Store'
            },
            android: {
                availableOn: 'Available on',
                nameStore: 'Google Play'
            }
        },
        match: 'Match',
        unmatched: 'Unmatched',
        uploadFile: 'Upload file',
        characters: {
            singular: 'character',
            plural: 'characters',
        },
        never: 'Never',
        tbd: 'TBD',
        select: {
            placeholder: 'Select...'
        },
        start: 'Start',
        done: 'Done',
        complete: 'Complete',
        unverified: 'Unverified',
        replace: 'Replace',
    },

    app: {
        title: 'OWQLO',
    },

    entities: {
        docs: {
            fields: {
                title: 'Title'
            }
        },

        people: {
            name: 'people',
            menu: 'People',
        },
        teamRegistration: {
            fields: {
                clubName: 'Club name',
                clubLegalName: 'Club corporate name',
                clubType: 'Type of club',
                clubFederation: 'Territorial federation',
                clubLegalEntityId: 'Company tax ID',
                clubWebsite: 'Club website',
                clubNeedsAccommodation: 'Are you going to need accommodation?',
                clubKitJersey: 'Jersey colors',
                clubKitPants: 'Pants colors',
            },
            placeholders: {
                clubLogo: 'Club crest',
                clubName: 'Club name',
                clubLegalName: 'E.g.: Rayo Vallecano de Madrid S.A.D.',
                clubType: 'Select one...',
                clubFederation: 'Select one...',
                clubLegalEntityId: 'Company tax ID',
                clubWebsite: 'e.g. www.atleticodemadridjunior.com',
            },
        },
        clubKitPiece: {
            fields: {
                type: 'Jersey type',
            },
        },
        clubContactPerson: {
            fields: {
                firstName: 'First name',
                lastName: 'Last name',
                position: 'Position',
                email: 'Email',
                phone: 'Phone number',
            },
            placeholders: {
                firstName: 'Person first name',
                lastName: 'Person last name',
                position: 'e.g. Coach',
                email: 'e.g. name@club.com',
            },
        },
        clubCategory: {
            fields: {
                gender: 'Gender',
                format: 'Format',
                ageCategory: 'Team category',
                multipleTeams: 'Are you going to register multiple teams in this category?',
                minimumPlayersCommitment: 'I confirm that a minimum of {0} players will be on this/these team/s roster',
            },
            placeholders: {
                ageCategory: 'Select one...',
                teamName: 'e.g. A, B, etc.',
            },
        },
        inscription: {
            name: 'Registration',
            label: 'Registrations',
            menu: 'Registrations',
            exporterFileName: 'inscription_export',
            list: {
                menu: 'Registrations',
                title: 'Registrations',
            },
            create: {
                success: 'Registration saved successfully',
            },
            update: {
                success: 'Registration saved successfully',
            },
            destroy: {
                success: 'Registration deleted successfully',
            },
            destroyAll: {
                success: 'Registration(s) deleted successfully',
            },
            edit: {
                title: 'Edit Registration',
            },
            fields: {
                id: 'Id',
                'status': 'Status',
                'user': 'Parent',
                'name': 'Name',
                'firstName': 'First name',
                'lastName': 'Last name',
                'birthdate': 'Birth Date',
                'gender': 'Gender',
                'isMember': 'Is already a member of this ${name}?',
                'careerInfo': 'Sports Career',
                'identDoc': 'ID Number',
                'identDocFiles': 'Uploading proof of Passport / ID document',
                'additionalDocFiles': 'Additional documents',
                'program': 'Program',
                'subprogram': 'Category',
                'emailParent': 'Email tutor',
                'nameParent': 'Name tutor',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
                birthdateRange: 'Birthdate',
            },
            placeholders: {
                firstName: 'Matthew',
                lastName: 'Williams',
                gender: 'Select one',
                birthdate: 'yyyy-mm-dd',
                careerInfo: 'My kid was a striker at...',
                identDoc: '12345678-X',
                additionalDocText: 'Please, download these documents and upload them signed.',
            },
            matching: {
                default: 'Select gender & birthdate in order to match with a subprogram',
                loading: 'Matching player, please wait...',
                error: 'Sorry, there\'s no team in this age group and gender',
                success: 'This player has been assigned to',
            },
            overview: {
                playersBornIn: 'Players born in {0}',
                playersBornInAnd: 'Players born in {0} and {1}',
                playersBornBetween: 'Players born between {0} and {1}',
                unknownError: 'Unexpected error, please contact support@owqlo.com',
                parentDocLabel: 'Write down the identification number of the parent to validate the registration',
            },
            pending: {
                title: 'Registration pending of approval',
                message: 'We sent you an email with all the information about your registration request.',
                buttonCaption: 'Go to home',
            },
            footer: {
                text: 'If you have any problem with the registration, please contact',
                email: 'support@owqlo.com',
            },
            form: {
                title: '<strong>Player</strong> Registration',
                subtitle: {
                    info: 'Player info',
                    confirmation: 'Confirmation',
                },
            },
            new: {
                title: 'Create Registration',
            },
            view: {
                title: 'View Registration',
                subtitle: {
                    familyMember: 'Family member',
                    player: 'Player'
                },
                fields: {
                    isMember: 'Former member?'
                },
                card: {
                    information: 'Information',
                    address: 'Address',
                    residentialAddress: 'Residential address',
                    programRegistration: 'Program registration',
                    verification: 'Verification',
                    aditionaDocuments: 'Aditional documents',
                }
            },
            importer: {
                title: 'Import Registration',
                fileName: 'inscription_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
            status: {
                pendingApproval: 'Pending approval'
            },
            modal: {
                title: 'Update Player'
            },
            almostDone: {
                title: 'Register your kid(s)',
                step1: {
                    label: 'OWQLO',
                    caption: 'Parent account created',
                },
                step2: {
                    caption: 'Register now your kid(s) to',
                },
            },
            remove: {
                title: 'You are about to remove a player',
                message: 'Are you sure?',
            },
        },
        academy: {
            name: 'academy',
            label: 'Academies',
            menu: 'Academies',
            exporterFileName: 'academy_export',
            list: {
                menu: 'Academies',
                title: 'Academies',
            },
            create: {
                success: 'Academy saved successfully',
            },
            update: {
                success: 'Academy saved successfully',
            },
            destroy: {
                success: 'Academy deleted successfully',
            },
            destroyAll: {
                success: 'Academy(s) deleted successfully',
            },
            edit: {
                title: 'Edit Academy',
            },
            fields: {
                id: 'Id',
                'name': 'Name',
                'propertyOwner': 'PropertyOwner',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {

            },
            new: {
                title: 'Create Academy',
            },
            view: {
                title: 'View Academy',
            },
            importer: {
                title: 'Import Academies',
                fileName: 'academy_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        player: {
            name: 'player',
            singular: 'Player',
            label: 'Players',
            amountOf: 'Number of players',
            empty: 'No players yet',
            tooltipCaption: 'Players currently active',
            menu: 'Players',
            exporterFileName: 'player_export',
            add: {
                one: 'Add player',
                many: 'Add players'
            },
            list: {
                menu: 'Players',
                title: 'Players',
            },
            create: {
                success: 'Player saved successfully',
            },
            update: {
                success: 'Player saved successfully',
            },
            destroy: {
                success: 'Player deleted successfully',
            },
            destroyAll: {
                success: 'Player(s) deleted successfully',
            },
            edit: {
                title: 'Edit Player',
            },
            fields: {
                id: 'Id',
                'teams': 'Teams',
                'name': 'Name',
                'firstName': 'First name',
                'lastName': 'Last name',
                'user': 'User',
                'birthdate': 'Birthdate',
                'picture': 'Picture',
                'country': 'Country',
                'gender': 'Gender',
                'isMember': 'Former member?',   //TODO:en
                'careerInfo': 'Sports Career',//TODO:en
                'program': 'Program',
                'subprogram': 'Subprogram',
                lastLogin: 'Last Login',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
                birthdateRange: 'Birthdate range',
            },
            enumerators: {
                'gender': {
                    'male': 'Male',
                    'female': 'Female',
                },
            },
            new: {
                title: 'Create Player',
            },
            view: {
                title: 'View Player',
                tabs: { 
                    profile: 'Profile',
                    inscription: 'Registration'
                },
                cards: {
                    profile: 'Profile'
                },
                btns: {
                    seeDetail: 'See detail'
                }
            },
            updateTeams: {
                action: 'Add teams',
                title: 'Add teams'
            },
            importer: {
                title: 'Import Players',
                fileName: 'player_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        coach: {
            name: 'coach',
            label: 'Coaches',
            amountOf: 'Number of coaches',
            tooltipCaption: 'Coaches currently active',
            empty: 'No coaches yet',
            menu: 'Coaches',
            exporterFileName: 'coach_export',
            list: {
                menu: 'Coaches',
                title: 'Coaches',
                multipleCoaches: 'Multiple Coaches'
            },
            create: {
                success: 'Coach saved successfully',
            },
            update: {
                success: 'Coach saved successfully',
            },
            destroy: {
                success: 'Coach deleted successfully',
            },
            destroyAll: {
                success: 'Coach(s) deleted successfully',
            },
            edit: {
                title: 'Edit Coach',
            },
            fields: {
                id: 'Id',
                'teams': 'Teams',
                'uid': 'Uid',
                'name': 'Name',
                'firstName': 'First Name',
                'lastName': 'Last Name',
                'birthdate': 'Birthdate',
                'email': 'Email',
                'phoneNumber': 'Phone Number',
                'gender': 'Gender',
                'country': 'Country',
                'type': 'Type',
                lastLogin: 'Last Login',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {
                'gender': {
                    'male': 'Male',
                    'female': 'Female',
                },
                'type': {
                    'coachHead': 'Head Coach',
                    'coachDirector': 'Director of Coaching',
                    'coach': 'Coach',
                    'coachAssistant': 'Coach Assistant',
                    'schoolManager': 'School Manager',
                    'teamManager': 'Team Manager'
                },
            },
            new: {
                title: 'Create Coach',
            },
            view: {
                title: 'View Coach',
            },
            importer: {
                title: 'Import Coaches',
                fileName: 'coach_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
            placeholders: {
                type: 'Select one...',
                firstName: 'Matthew',
                lastName: 'Williams',
                birthdate: 'yyyy-mm-dd',
                gender: 'Select one...',
                country: 'Select one...',
                email: 'email@domain.com',
                teams: 'Select one...'
            },
            form: {
                subtitle: {
                    information: 'Information',
                    teams: 'Teams'
                },
                tooltip: {
                    emailDisabled: 'For privacy reasons we do not allow you to change the email address ',
                }
            },
        },

        parent: {
            name: 'parent',
            label: 'Parents',
            amountOf: 'Number of parents',
            tooltipCaption: 'Parents currently active',
            empty: 'No parents yet',
            menu: 'Parents',
            exporterFileName: 'parent_export',
            list: {
                menu: 'Parents',
                title: 'Parents',
            },
            create: {
                success: 'Parent saved successfully',
            },
            update: {
                success: 'Parent saved successfully',
            },
            destroy: {
                success: 'Parent deleted successfully',
            },
            destroyAll: {
                success: 'Parent(s) deleted successfully',
            },
            edit: {
                title: 'Edit Parent',
            },
            fields: {
                id: 'Id',
                family: 'Family',
                name: 'Name',
                firstName: 'First Name',
                lastName: 'Last Name',
                gender: 'Gender',
                birthdate: 'Date of birth',
                address: 'Address',
                email: 'Email',
                phoneNumber: 'Phone Number',
                lastLogin: 'Last Login',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
                birthdateRange: 'Birthdate',
            },
            enumerators: {

            },
            new: {
                title: 'Create Parent',
            },
            view: {
                title: 'View Parent',
            },
            importer: {
                title: 'Import Parents',
                fileName: 'parent_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        family: {
            name: 'family',
            label: 'Families',
            amountOf: 'Number of families',
            empty: 'No families yet',
            menu: 'Families',
            exporterFileName: 'parent_export',
            list: {
                menu: 'Families',
                title: 'Families',
            },
            create: {
                success: 'Family saved successfully',
            },
            update: {
                success: 'Family saved successfully',
            },
            destroy: {
                success: 'Family deleted successfully',
            },
            destroyAll: {
                success: 'Familie(s) deleted successfully',
            },
            edit: {
                title: 'Edit Family',
            },
            fields: {
                id: 'Id',
                'gender': 'Gender',
                'children': 'Children',
                'country': 'Country',
                'email': 'Email',
                'role': 'Role',
                'birthdate': 'Birthdate',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            new: {
                title: 'Create Family',
            },
            view: {
                title: 'View Family',
            },
        },

        news: {
            name: 'news',
            label: 'News',
            menu: 'News',
            exporterFileName: 'news_export',
            list: {
                menu: 'News',
                title: 'News',
            },
            create: {
                success: 'News saved successfully',
            },
            update: {
                success: 'News saved successfully',
            },
            destroy: {
                success: 'News deleted successfully',
            },
            destroyAll: {
                success: 'News(s) deleted successfully',
            },
            edit: {
                title: 'Edit News',
            },
            fields: {
                id: 'Id',
                'title': 'Title',
                'subtitle': 'Subtitle',
                'contentHtml': 'ContentHtml',
                'description': 'Description',
                'sourceUrl': 'SourceUrl',
                'media': 'Media',
                'status': 'Status',
                'propertyOwner': 'PropertyOwner',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {
                'status': {
                    'draft': 'Draft',
                    'published': 'Published',
                },
            },
            new: {
                title: 'Create News',
            },
            view: {
                title: 'View News',
            },
            importer: {
                title: 'Import News',
                fileName: 'news_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        training: {
            name: 'training',
            label: 'Trainings',
            menu: 'Trainings',
            exporterFileName: 'training_export',
            list: {
                menu: 'Trainings',
                title: 'Trainings',
            },
            create: {
                success: 'Training saved successfully',
            },
            update: {
                success: 'Training saved successfully',
            },
            destroy: {
                success: 'Training deleted successfully',
            },
            destroyAll: {
                success: 'Training(s) deleted successfully',
            },
            edit: {
                title: 'Edit Training',
            },
            fields: {
                id: 'Id',
                'title': 'Title',
                'description': 'Description',
                'dateRange': 'Date',
                'date': 'Date',
                'hour': 'Hour',
                'duration': 'Duration',
                'location': 'Location',
                'status': 'Status',
                'team': 'Team',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {

            },
            new: {
                title: 'Create Training',
            },
            view: {
                title: 'View Training',
            },
            importer: {
                title: 'Import Trainings',
                fileName: 'training_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        game: {
            name: 'game',
            label: {
                one: 'Game',
                many: 'Games',
            },
            menu: 'Games',
            exporterFileName: 'game_export',
            subtitle: {
                information: 'Game information'
            },
            list: {
                menu: 'Games',
                title: 'Games',
                empty: {
                    location: 'Without location',    // TODO:nba
                    date: 'Without date',     // TODO:nba
                    hour: 'Without hour',    // TODO:nba
                    school: 'Without school',    // TODO:nba
                }
            },
            create: {
                success: 'Game saved successfully',
            },
            update: {
                success: 'Game saved successfully',
            },
            destroy: {
                success: 'Game deleted successfully',
            },
            destroyAll: {
                success: 'Game(s) deleted successfully',
            },
            edit: {
                title: 'Edit Game',
            },
            fields: {
                id: 'Id',
                'awayTeam': 'Away team',
                'homeTeam': 'Home team',
                'timestamp': 'Date and hour',
                'date': 'Date',
                'hour': 'Hour',
                'duration': 'Duration',
                'location': 'Location',
                'status': 'Status',
                'type': 'Type',
                'teams': 'Teams',
                'results': 'Score',
                'locationInfo': 'Extra location information',
                'dateRange': 'Date range',
                'teamToFilter': 'Team',
                'regularSeasonRound': 'Round',
                'playoff': 'Playoff',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            placeholders: {
                hour: '4:00 PM',
                location: 'Location',
                locationInfo: 'Field 1',
                timestamp: 'Selecciona fecha y hora ',
            },
            enumerators: {
                // 'status': {
                //     'toPlay': 'ToPlay',
                //     'firstHalf': 'FirstHalf',
                //     'halfTime': 'HalfTime',
                //     'secondHalf': 'SecondHalf',
                //     'toEnd': 'ToEnd',
                //     'penaltyShootout': 'PenaltyShootout',
                //     'played': 'Played',
                // },
            },
            new: {
                title: 'Create Game',
            },
            view: {
                title: 'View Game',
            },
            importer: {
                title: 'Import Games',
                fileName: 'game_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        event: {
            name: 'event',
            label: 'Events',
            menu: 'Events',
            exporterFileName: 'event_export',
            list: {
                menu: 'Events',
                title: 'Events',
            },
            create: {
                success: 'Event saved successfully',
            },
            update: {
                success: 'Event saved successfully',
            },
            destroy: {
                success: 'Event deleted successfully',
            },
            destroyAll: {
                success: 'Event(s) deleted successfully',
            },
            edit: {
                title: 'Edit Event',
            },
            fields: {
                id: 'Id',
                'title': 'Title',
                'description': 'Description',
                'dateRange': 'Date',
                'date': 'Date',
                'hour': 'Hour',
                'duration': 'Duration',
                'location': 'Location',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {

            },
            new: {
                title: 'Create Event',
            },
            view: {
                title: 'View Event',
            },
            importer: {
                title: 'Import Events',
                fileName: 'event_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        team: {
            name: 'team',
            label: { 
                one: 'Team',
                many: 'Teams'
            },
            amountOf: 'Number of teams',
            tooltipCaption: 'Teams currently active',
            empty: 'No teams yet',
            menu: 'Teams',
            exporterFileName: 'team_export',
            list: {
                menu: 'Teams',
                title: 'Teams',
                multipleTeams: 'Multiple teams'
            },
            create: {
                success: 'Team saved successfully',
            },
            update: {
                success: 'Team updated successfully',
            },
            destroy: {
                success: 'Team deleted successfully',
            },
            destroyAll: {
                success: 'Team(s) deleted successfully',
            },
            edit: {
                title: 'Edit Team',
            },
            fields: {
                id: 'Id',
                'name': 'Name',
                'category': 'Category',
                'program': 'Program',
                'subprogram': 'Subprogram',
                'logo': 'Logo',
                'players': 'Nº Players',
                'coaches': 'Coaches',
                'isMatched': 'Is matched',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {
                player: {
                    one: 'Player',
                    many: 'Players'
                }
            },
            new: {
                title: 'Create Team',
            },
            view: {
                title: 'View Team',
            },
            importer: {
                title: 'Import Teams',
                fileName: 'team_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        position: {
            name: 'position',
            label: 'Positions',
            menu: 'Positions',
            exporterFileName: 'position_export',
            list: {
                menu: 'Positions',
                title: 'Positions',
            },
            create: {
                success: 'Position saved successfully',
            },
            update: {
                success: 'Position saved successfully',
            },
            destroy: {
                success: 'Position deleted successfully',
            },
            destroyAll: {
                success: 'Position(s) deleted successfully',
            },
            edit: {
                title: 'Edit Position',
            },
            fields: {
                id: 'Id',
                'name': 'Name',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {

            },
            new: {
                title: 'Create Position',
            },
            view: {
                title: 'View Position',
            },
            importer: {
                title: 'Import Positions',
                fileName: 'position_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        fan: {
            name: 'fan',
            label: 'Fans',
            menu: 'Fans',
            exporterFileName: 'fan_export',
            list: {
                menu: 'Fans',
                title: 'Fans',
            },
            create: {
                success: 'Fan saved successfully',
            },
            update: {
                success: 'Fan saved successfully',
            },
            destroy: {
                success: 'Fan deleted successfully',
            },
            destroyAll: {
                success: 'Fan(s) deleted successfully',
            },
            edit: {
                title: 'Edit Fan',
            },
            fields: {
                id: 'Id',
                'name': 'Name',
                'lastName': 'LastName',
                'picture': 'Picture',
                'uid': 'Uid',
                'teams': 'Teams',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {

            },
            new: {
                title: 'Create Fan',
            },
            view: {
                title: 'View Fan',
            },
            importer: {
                title: 'Import Fans',
                fileName: 'fan_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        sheetEvent: {
            name: 'sheetEvent',
            label: 'SheetEvents',
            menu: 'SheetEvents',
            exporterFileName: 'sheetEvent_export',
            list: {
                menu: 'SheetEvents',
                title: 'SheetEvents',
            },
            create: {
                success: 'SheetEvent saved successfully',
            },
            update: {
                success: 'SheetEvent saved successfully',
            },
            destroy: {
                success: 'SheetEvent deleted successfully',
            },
            destroyAll: {
                success: 'SheetEvent(s) deleted successfully',
            },
            edit: {
                title: 'Edit SheetEvent',
            },
            fields: {
                id: 'Id',
                'type': 'Type',
                'subtypeGame': 'SubtypeGame',
                'subtypeGoal': 'SubtypeGoal',
                'subtypeCard': 'SubtypeCard',
                'subtypePenaltyShootout': 'SubtypePenaltyShootout',
                'teamId': 'TeamId',
                'minuteRange': 'Minute',
                'minute': 'Minute',
                'player': 'Player',
                'otherTeamId': 'OtherTeamId',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {
                'type': {
                    'game': 'Game',
                    'goal': 'Goal',
                    'card': 'Card',
                    'penaltyShootout': 'PenaltyShootout',
                },
                'subtypeGame': {
                    'start': 'Start',
                    'firstHalfEnd': 'FirstHalfEnd',
                    'seconndHalfStart': 'SeconndHalfStart',
                    'secondHalfEnd': 'SecondHalfEnd',
                    'end': 'End',
                    'cancelStart': 'CancelStart',
                },
                'subtypeGoal': {
                    'standard': 'Standard',
                    'own': 'Own',
                    'penalty': 'Penalty',
                },
                'subtypeCard': {
                    'yellowCard': 'YellowCard',
                    'redCard': 'RedCard',
                },
                'subtypePenaltyShootout': {
                    'start': 'Start',
                    'goal': 'Goal',
                    'fail': 'Fail',
                    'end': 'End',
                },
            },
            new: {
                title: 'Create SheetEvent',
            },
            view: {
                title: 'View SheetEvent',
            },
            importer: {
                title: 'Import SheetEvents',
                fileName: 'sheetEvent_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        site: {
            name: 'site',
            label: 'Sites',
            menu: 'Sites',
            exporterFileName: 'site_export',
            list: {
                menu: 'Sites',
                title: 'Sites',
            },
            create: {
                success: 'Site saved successfully',
            },
            update: {
                success: 'Site saved successfully',
            },
            destroy: {
                success: 'Site deleted successfully',
            },
            destroyAll: {
                success: 'Site(s) deleted successfully',
            },
            edit: {
                title: 'Edit Site',
            },
            fields: {
                id: 'Id',
                'name': 'Name',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {

            },
            new: {
                title: 'Create Site',
            },
            view: {
                title: 'View Site',
            },
            importer: {
                title: 'Import Sites',
                fileName: 'site_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        club: {
            name: 'club',
            label: 'Clubs',
            menu: 'Clubs',
            exporterFileName: 'club_export',
            list: {
                menu: 'Clubs',
                title: 'Clubs',
            },
            create: {
                success: 'Club saved successfully',
            },
            update: {
                success: 'Club saved successfully',
            },
            destroy: {
                success: 'Club deleted successfully',
            },
            destroyAll: {
                success: 'Club(s) deleted successfully',
            },
            edit: {
                title: 'Edit Club',
            },
            fields: {
                id: 'Id',
                'name': 'Name',
                'logo': 'Logo',
                'teams': 'Teams',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {

            },
            new: {
                title: 'Create Club',
            },
            view: {
                title: 'View Club',
            },
            importer: {
                title: 'Import Clubs',
                fileName: 'club_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        service: {
            name: 'service',
            label: 'Services',
            menu: 'Services',
            exporterFileName: 'service_export',
            list: {
                menu: 'Services',
                title: 'Services',
            },
            create: {
                success: 'Service saved successfully',
            },
            update: {
                success: 'Service saved successfully',
            },
            destroy: {
                success: 'Service deleted successfully',
            },
            destroyAll: {
                success: 'Service(s) deleted successfully',
            },
            edit: {
                title: 'Edit Service',
            },
            fields: {
                id: 'Id',
                'name': 'Name',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {

            },
            new: {
                title: 'Create Service',
            },
            view: {
                title: 'View Service',
            },
            importer: {
                title: 'Import Services',
                fileName: 'service_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        property: {
            name: 'property',
            label: 'Properties',
            menu: 'Properties',
            exporterFileName: 'property_export',
            list: {
                menu: 'Properties',
                title: 'Properties',
                multipleManagers: 'Multiple managers',
                filters: 'Filters'
            },
            create: {
                success: 'Property saved successfully',
            },
            update: {
                success: 'Property saved successfully',
            },
            destroy: {
                success: 'Property deleted successfully',
            },
            destroyAll: {
                success: 'Property(s) deleted successfully',
            },
            edit: {
                title: 'Edit Property',
            },
            fields: {
                id: 'Id',
                'name': 'Property name',
                'access': 'Access',
                'sport': 'Sport',
                'status': 'Status',
                'country': 'Property country',
                'logos': 'Logos',
                'type': 'Type',
                'programs': 'Programs',
                'managers': 'Managers',
                'maxNumSubproperty': 'Number of subproperties',
                email: 'Email',
                emails: 'Email(s)',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            placeholders: {
                'name': 'Madrid CFF',
                'sport': 'Soccer',
                'country': 'Country',
                'type': 'Club',
                'maxNumSubproperty': '1',
                'uploadFile': 'Upload file',
                'access': 'Private',
                'email': 'email@domain.com',
                'noData': 'There are no matches in the search'
            },
            form: {
                subtitle: {
                    information: 'Property information',
                    management: 'Management',
                    subproperties: 'Subproperties',
                    country: 'Country',
                },
                description: {
                    email: 'Add the managers of the property so they receive an email to register'
                }
            },
            enumerators: {
                'sport': {
                    'basketball': 'Basketball',
                    'soccer': 'Soccer',
                },
                'status': {
                    'enabled': 'Enabled',
                    'disabled': 'Disable',
                },
                'access': {
                    'private': 'Private',
                    'public': 'Public',
                },
            },
            new: {
                title: 'Create property',
                button: 'Create property'
            },
            view: {
                title: 'View Property',
            },
            importer: {
                title: 'Import Properties',
                fileName: 'property_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
            requirementSteps: {
                title: 'Welcome {0}!',
                caption: 'To start using your account, you must complete these steps.',
                progressCaption: '{0} step(s) to be completed',
                tooltipCaption: 'Finish the steps to continue',
                steps: {
                    property: {
                        title: 'Complete your property',
                        linkCaption: 'Submit information'
                    },
                    profile: {
                        title: 'Complete your profile',
                        linkCaption: 'Submit information'
                    },
                }
            },
        },

        subproperty: {
            name: 'subproperty',
            label: 'Subproperties',
            menu: ' Subproperties',
            empty: 'No subproperty yet',
            exporterFileName: 'subproperty_export',
            list: {
                menu: 'Subproperties',
                title: 'Subproperties',
                multipleManagers: 'Multiple managers'
            },
            create: {
                success: 'Subproperty saved successfully',
            },
            update: {
                success: 'Subproperty saved successfully',
            },
            destroy: {
                success: 'Subproperty deleted successfully',
            },
            destroyAll: {
                success: 'Subproperty(s) deleted successfully',
            },
            edit: {
                title: 'Edit Subproperty',
            },
            fields: {
                id: 'Id',
                'name': 'Subproperty name',
                'slug': 'Setting url', // TODO:en
                'status': 'Status',
                'access': 'Access',
                'country': 'Country',
                'region': 'Region',
                'managers': 'Managers',
                'logo': 'Logo',
                'programs': 'Active programs',
                'paymentsEnabled': 'Stripe payment capabilities enabled?',
                'owqloFeeFixed': 'Fixed fee',
                'owqloFeePercentage': 'Variable fee',
                'email': 'Email',
                'emails': 'Email(s)',
                'createdAt': 'Created at',
                'updatedAt': 'Updated at',
                'createdAtRange': 'Created at',
                'birthdateType': 'Select with which parameter you want to define your categories',
                'dateFormat': 'Date format',
                'timeFormat': 'Time format',
            },
            placeholders: {
                'name': 'Subproperty name',
                'slug': 'Slug',
                'status': 'Status',
                'access': 'Access',
                'country': 'Country',
                'region': 'Region',
                'logo': 'Logo',
                email: 'name@domain.com',
                emails: 'Email(s)',
            },
            form: {
                subtitle: {
                    information: 'Information',
                    management: 'Management',
                    settings: 'Settings',
                },
                description: {
                    email: 'Add the managers so that they receive an email and can register'
                }
            },
            enumerators: {
                // 'access': {
                //   'private': 'Private',
                //   'public': 'Public',
                // },
            },
            new: {
                title: 'Subproperty creation',
                button: 'Create subproperty'
            },
            view: {
                title: 'View Subproperty',
            },
            importer: {
                title: 'Import Subproperties',
                fileName: 'subproperty_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
            requirementSteps: {
                title: 'Welcome {0}!',
                caption: 'To start managing your property, you must complete these steps.',
                progressCaption: '{0} step(s) to be completed',
                tooltipCaption: 'Finish the steps to continue',
                steps: {
                    categories: {
                        title: 'Create your default categories',
                        linkCaption: 'Create categories',
                    },
                    locations: {
                        title: 'Create your locations',
                        linkCaption: 'Create locations',
                    },
                    setup: {
                        title: 'Add company information for financial accounting',
                        linkCaption: 'Connected account'
                    },
                    people: {
                        title: 'Add information about company related persons',
                        linkCaption: 'Connected persons'
                    },
                    externalAccounts: {
                        title: 'Add payout methods',
                        linkCaption: 'Payout method'
                    },
                    payouts: {
                        title: 'Configure automatic withdrawal of funds',
                        linkCaption: 'Payout schedule'
                    },
                    slug: {
                        title: 'Customize a link for your website',
                        linkCaption: 'Web link'
                    }
                }
            },
            finantialOverview: {
                title: 'Subproperty details',
                slugCard: {
                    configSlugText: 'Configure your URL to be found by your users',
                    emptyText: `There's no URL configured yet`,
                    infoText: 'Complete the steps above to add the URL',
                    linkText: 'See details'
                },
                feeCard: {
                    infoText: 'Complete the steps above to add fee',
                    owqloFeeText: `Processing payment fee`,
                    linkText: 'See details'
                },
                connectedAccountCard: {
                    emptyText: `There's not connected account yet`,
                    infoText: 'Complete the steps above to add an account',
                    connectedAccountText: 'Connected account',
                    connectedAccountDisabledText: 'Connected account disabled; see details, or contact support@owqlo.com',
                    connectedAccountIncompleteText: 'Connected account is incomplete; it will be disabled until you complete the steps above',
                    enabled: 'Enabled',
                    disabled: 'Disabled'
                }
            },
            customize: {
                title: 'Initial Settings',
                subtitles: {
                    information: 'Information'
                },
                suportedCharacters: 'Supported characters: a-z, A-Z, 0-9, dash (-)',
                checkExists: {
                    loading: 'Checking if URL already exists',
                    error: 'URL already exists',
                    success: 'URL is available',
                },
                labels: {
                    currentUrl: 'Current URL',
                    newUrl: 'New URL'
                },
                noUrlSlug: 'No configured URL yet',
                update: {
                    success: 'URL saved successfully',
                },
            },
            feeInfo: {
                title: 'Commission for payments',
                description: 'Stripe commission and operation costs',
                feeCardInfo: {
                    forEuropean: 'For European cards',
                    forNonEuropean: 'For non European cards',
                    forCountry: 'For national cards',
                    forInternational: 'For international cards',
                },
                checkList: {
                    0: 'Everything you need to manage payments',
                    1: 'No monthly, hidden or setup fees'
                },
                smallText:'*If currency conversion is required, an additional {0} commission will be applied'
            },
        },

        base: {
            name: 'base',
            label: 'Bases',
            menu: 'Bases',
            empty: 'No bases yet',
            list: {
                menu: 'Bases',
                title: 'Bases',
            },
            create: {
                success: 'Base saved successfully',
            },
            update: {
                success: 'Base saved successfully',
            },
            destroy: {
                success: 'Base deleted successfully',
            },
            destroyAll: {
                success: 'Base(s) deleted successfully',
            },
            fields: {
                id: 'Id',
                'name': 'Base name',
                'seasons': 'Seasons',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            new: {
                title: 'Create Base',
            },
            edit: {
                title: 'Edit Base',
            },
            view: {
                title: 'View Base',
            },
        },

        category: {
            name: 'category',
            label: {
                one: 'Category',
                many: 'Categories'
            },
            menu: 'Categories',
            defaultCategories: 'Default categories',
            ageCategories: 'Age categories',
            exporterFileName: 'category_export',
            list: {
                menu: 'Categories',
                title: 'Categories',
                multipleCategories: 'Multiple categories',
            },
            create: {
                success: 'Category saved successfully',
            },
            update: {
                success: 'Category saved successfully',
            },
            destroy: {
                success: 'Category deleted successfully',
            },
            destroyAll: {
                success: 'Category(s) deleted successfully',
            },
            edit: {
                title: 'Edit Category',
            },
            fields: {
                id: 'Id',
                'name': 'Name',
                'label': 'Shortname',
                'index': 'Index',
                'minBirthDate': 'Born from',
                'maxBirthDate': 'Born until',
                'intervalBirthYear': 'Born between',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {

            },
            new: {
                title: 'Create Category',
            },
            view: {
                title: 'View Category',
            },
            importer: {
                title: 'Import Categories',
                fileName: 'category_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
            placeholders: {
                yearStart: 'Year (Start)',
                yearEnd: 'Year (End)',
            },
        },

        season: {
            name: 'season',
            label: 'Seasons',
            menu: 'Seasons',
            exporterFileName: 'season_export',
            amountOf: 'Number of seasons',
            empty: 'No seasons yet',
            tooltipCaption: 'Seasons currently active',
            list: {
                menu: 'Seasons',
                title: 'Seasons',
                singular: 'Season'
            },
            create: {
                success: 'Season saved successfully',
            },
            update: {
                success: 'Season saved successfully',
            },
            destroy: {
                success: 'Season deleted successfully',
            },
            destroyAll: {
                success: 'Season(s) deleted successfully',
            },
            edit: {
                title: 'Edit Season',
            },
            fields: {
                id: 'Id',
                'description': 'Description',
                'type': 'Type of season',
                'name': 'Name of season',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            new: {
                title: 'Create Season',
            },
            view: {
                title: 'View Season',
            },
            importer: {
                title: 'Import Seasons',
                fileName: 'season_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        location: {
            name: 'location',
            label: 'Locations',
            amountOf: 'Number of locations',
            tooltipCaption: 'Locations currently active',
            empty: 'No locations yet',
            menu: 'Locations',
            exporterFileName: 'location_export',
            list: {
                menu: 'Locations',
                title: 'Locations',
            },
            create: {
                success: 'Location saved successfully',
            },
            update: {
                success: 'Location saved successfully',
            },
            destroy: {
                success: 'Location deleted successfully',
            },
            destroyAll: {
                success: 'Location(s) deleted successfully',
            },
            edit: {
                title: 'Edit Location',
            },
            fields: {
                id: 'Id',
                'name': 'Location name',
                'information': 'Information',
                'location': 'Location',
                'access': 'Access',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {
                'access': {
                    'private': 'Private',
                    'public': 'Public',
                },
            },
            new: {
                title: 'Create Location',
            },
            view: {
                title: 'View Location',
            },
            importer: {
                title: 'Import Locations',
                fileName: 'location_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
            placeholders: {
              search: 'Search',
              information: 'Field 1'
            }
        },

        price: {
            name: 'price',
            label: 'Prices',
            menu: 'Prices',
            exporterFileName: 'price_export',
            list: {
                menu: 'Prices',
                title: 'Prices',
            },
            create: {
                success: 'Price saved successfully',
            },
            update: {
                success: 'Price saved successfully',
            },
            destroy: {
                success: 'Price deleted successfully',
            },
            destroyAll: {
                success: 'Price(s) deleted successfully',
            },
            edit: {
                title: 'Edit Price',
            },
            fields: {
                id: 'Id',
                'amountRange': 'Amount',
                'amount': 'Amount',
                'currency': 'Currency',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {
                'currency': {
                    'eu': 'EU',
                    'usd': 'USD',
                },
            },
            new: {
                title: 'Create Price',
            },
            view: {
                title: 'View Price',
            },
            importer: {
                title: 'Import Prices',
                fileName: 'price_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        paymentOption: {
            name: 'payment option',
            label: 'Payment option',
            menu: 'Payment option',
            exporterFileName: 'payment-option_export',
            list: {
                menu: 'Payment options',
                title: 'Payment options',
            },
            create: {
                success: 'Payment option saved successfully',
            },
            update: {
                success: 'Payment option saved successfully',
            },
            destroy: {
                success: 'Payment option deleted successfully',
            },
            destroyAll: {
                success: 'Payment option(s) deleted successfully',
            },
            edit: {
                title: 'Edit Payment option',
            },
            fields: {
                id: 'Id',
                'type': 'Type',
                'status': 'Status',
                'numberOfPayments': 'Number Of Payments',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            enumerators: {
                'type': {
                    'standard': 'Standard',
                    'installment': 'Installment',
                    'suscription': 'Suscription',
                },
                'status': {
                    'enabled': 'Enabled',
                    'disabled': 'Disabled',
                }
            },
            new: {
                title: 'Create Payment option',
            },
            view: {
                title: 'View Payment option',
            },
            importer: {
                title: 'Import Payment options',
                fileName: 'payment-option_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },

        program: {
            name: 'program',
            label: {
                one: 'Program',
                many: 'Programs'
            },
            amountOf: 'Number of programs',
            tooltipCaption: 'Programs currently active',
            empty: 'No programs yet',
            menu: 'Programs',
            formSteps: {
                first: 'INFORMATION',
                second: 'MORE INFORMATION',
                third: 'PUBLISH',
            },
            exporterFileName: 'program_export',
            list: {
                menu: 'Programs',
                title: 'Programs',
                multipleSeasons: 'Multiple seasons',
                multipleLocations: 'Multiple locations',
                starts: 'Starts',
                ends: 'Ends',
            },
            create: {
                success: 'Program saved successfully',
            },
            update: {
                success: 'Program saved successfully',
            },
            destroy: {
                success: 'Program deleted successfully',
            },
            destroyAll: {
                success: 'Program(s) deleted successfully',
            },
            fields: {
                id: 'Id',
                'name': 'Program name',
                'sport': 'Sport',
                'type': 'Type of program',
                'season': 'Season',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },

            placeholders: {
                season: 'Season 2019/2020',
                name: 'Program name',
            },

            enumerators: {
                'type': {
                    'camp': 'Camp',
                    'class': 'Class',
                    'academy': 'Academy',
                    'league': 'League',
                    'tournament': 'Tournament',
                    'club': 'Club',
                    'school': 'School',
                },
            },
            new: {
                title: 'Create Program',
                programType: {
                    'all': 'All',
                    'club': 'Create Club',
                    'school': 'Create School',
                    'campclinics': 'Create Camps & Clinics',
                    'league': 'Create League',
                    'tournament': 'Create Tournament',
                },
            },
            edit: {
                title: 'Edit Program',
                programType: {
                    'all': 'All',
                    'club': 'Edit Club',
                    'school': 'Edit School',
                    'campclinics': 'Edit Camps & Clinics',
                    'league': 'Edit League',
                    'tournament': 'Edit Tournament',
                },
            },
            view: {
                title: 'View Program',
            },
            form: {
                subtitle: {
                    information: 'Information'
                }
            }, 
            importer: {
                title: 'Import Programs',
                fileName: 'program_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
        },
        subprogram: {
            name: 'subprogram',
            label: 'Subprograms',
            menu: 'Subprograms',
            exporterFileName: 'subprogram_export',
            formatDate: 'MMMM Do',
            list: {
                menu: 'Subprograms',
                title: 'Subprograms',
                multipleDays: 'Multiple days',
            },
            create: {
                success: 'Subprogram saved successfully',
            },
            update: {
                success: 'Subprogram saved successfully',
            },
            destroy: {
                success: 'Subprogram deleted successfully',
            },
            destroyAll: {
                success: 'Subprogram(s) deleted successfully',
            },
            edit: {
                title: 'Edit Subprogram',
            },
            fields: {
                id: 'Id',
                'name': 'Title',
                'type': 'Type',
                'category': 'Category',
                'categoryName': 'Category name', 
                'bornBetween': 'Born between',
                'time': 'Schedule',
                'dates': 'Dates',
                'subprogramDays': 'Days',
                'startDate': 'Starts',
                'endDate': 'Ends',
                'dateRange': 'Start and end date',
                'duration': 'Duration',
                'gender': 'Gender',
                'season': 'Season',
                'locations': 'Locations',
                'access': 'Access',
                'status': 'Status',
                'identDocNeeded': 'Identification document required?',
                'competitions': {
                    title: 'Competitions',
                    btn: 'Competitions',
                    label: 'In which competitions the teams of this category participate in?'
                },
                payment: {
                    title: 'Payment',
                    exist: 'Payment program?',
                    price: 'Price',
                    type: 'Type payment',
                    paymentOptions: 'Payment options',
                    externalAccount: 'Destination Account',
                },
                tryout: {
                    title: 'Tryout',
                    exist: 'Is there a tryout term?',
                    startDate: 'Start date',
                    endDate: 'End date',
                },
                additionalDoc: {
                    title: 'Is any additional document required?',
                    exist: 'Is any additional document required?',
                    text: 'Write down the necessary information so that the user knows what to do',
                },
                email: 'Email',
                emails: 'Email(s)',
                managers: 'Managers(s)',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
                regularSeasonHasRounds: 'Does the league have rounds?'
            },

            placeholders: {
                'name': 'Title',
                'type': 'Type',
                'category': 'Select one...',
                'time': 'Schedule',
                'subprogramDays': 'Days',
                'startDate': 'mm-dd-yyyy',
                'endDate': 'mm-dd-yyyy',
                'duration': 'Duration',
                'gender': 'Select one...',
                'season': 'Season',
                'locations': 'Locations',
                'access': 'Access',
                'status': 'Status',
                'price': 'Set a price',
                tryout: {
                    startDate: 'Start date',
                    endDate: 'End date',
                },
            },

            form: {
                btnSubmit: {
                    asDraft: 'Save as draft',
                    asPublish: 'Publish'
                },
                subtitle: {
                    information: 'Information',
                    paymentInformation: 'Payment information',
                    price: 'Price',
                    selectPaymentOptions: 'Select payment options',
                    moreInformation: 'More information',
                    access: 'Access',
                    tryout: 'Tryout',
                    competitionLeague: 'Competition league',
                    requiredDocuments: 'Required documents',
                    paymentActivity: 'Payment activity'
                },
                payment: {
                    fee: {
                        label: 'Fee', 
                        forEuropean: 'For European cards',
                        forNonEuropean: 'For non European cards',
                        forCountry: 'For national cards',
                        forInternational: 'For international cards',
                        seeDetailsText: 'See',
                        seeDetailsLinkText: 'details',
                    },
                    toReceive: {
                        label: 'To receive',
                        forEuropean: 'For European cards',
                        forNonEuropean: 'For non European cards',
                        forCountry: 'For national cards',
                        forInternational: 'For international cards',
                    },
                    infoText: {
                        draft: 'We are improving the platform to be able to offer more forms of payment.',
                        noDraft: 'This subprogram has already been published, therefore the payment information is not editable.',
                    },
                    descriptionPrice: 'Enter the price of the category in the form, and display the amount to receive with the commissions applied.', //TODO:es
                }
            },      
            modal: {
                status: {
                    message: 'Are you sure you want to update the status?',
                }
            },
            enumerators: {
                payment: {
                    type: {
                        standard: 'Unique',
                    } 
                }
            },
            new: {
                title: 'Create Subprogram',
            },
            view: {
                title: 'View Subprogram',
            },
            importer: {
                title: 'Import Subprograms',
                fileName: 'subprogram_import_template',
                hint: 'Files/Images columns must be the URLs of the files separated by space.',
            },
            nba: {
                tabs: {
                    summary: 'Summary',
                    schedule: 'Schedule',
                    standings: 'Standings',
                    participants: 'Participants',
                    players: 'Players',
                    parents: 'Parents', 
                    rounds: 'Rounds'
                },
                conference: {
                    teams: 'Teams',
                    pairing: 'To Match',
                    east: {
                        title: 'Eastern Conference',
                        division: {
                            southeast: 'Southeast Division',
                            atlantic: 'Atlantic Division',
                            central: 'Central Division',
                        },
                    },
                    west: {
                        title: 'Western Conference',
                        division: {
                            northwest: 'Northwest Division',
                            pacific: 'Pacific Division',
                            southwest: 'Southwest Division',
                        },
                    }
                },
                rounds: {
                    name: 'Round',
                    label: 'Rounds',
                    empty: 'No rounds yet',
                    add: 'Add a round',
                    edit: 'Edit round',
                    fields: {
                        id: 'Id',
                        hostingSchoolDivisionIndex: 'Hosting school',
                        startDate: 'Start date',
                        endDate: 'End date',
                        gamesConfigurationString: 'Games'
                    },
                    form: {
                        subtitle: 'Information of the round',
                        placeholders: {
                            gamesConfigurationString: 'For example: 1v3, 2v3, 3v1',
                        }
                    },
                    create: 'Round created successfully',
                    update: 'Round updated successfully',
                    destroy: 'Round deleted successfully'
                },
                playoffs: {
                    name: 'Playoffs'
                },
                create: {
                    title: 'Create games',
                },
                edit: {
                    title: 'Edit category',
                },
                startSeason: {
                    button: 'Start season',
                    alerts: {
                        first: {
                            title: 'The competition begins!',
                            description: 'If you click Continue, the competition will begin and all the matches in your league will be created. Are you sure?'
                        },
                        second: {
                            title: 'There are unmatched teams!',
                            description: 'There are {0} teams left to match, are you sure you want to create all the matches?'
                        },
                        third: {
                            title: 'Creating matches...',
                            description: ''
                        },
                        four: {
                            title: 'Matches created successfully!',
                            description: 'You can now edit the matches to add the location and time'
                        },
                        five: {
                            title: 'There are rounds that have not been configured!',
                            description: 'You cannot begin a season until you have a minimum of 2 rounds created.',
                        },
                        results: {
                            title: 'You are going to close the game score!',
                            action: 'If you click continue, you will close the score of the game. The result will be:',
                            description: 'We will send an email notifying the coaches and you of the game details and the final result.'
                        },
                    },
                },
                startPlayoffs: {
                    button: 'Start playoffs',
                    alerts: {
                        step1: {
                            title: 'The playoff round is about to begin!',
                            description: 'If you click continue, you will start creating the playoff games. Are you sure?'
                        },
                        step2: {
                            title: 'Creating matches...',
                            description: ''
                        },
                        step3: {
                            title: 'Matches created successfully!',
                            description: 'You can now edit the matches to add the location and time'
                        },
                        warning: {
                          title: 'There are still {0} games to play!',
                          description: "It's not possible to start the competition until all games of the previous round are played",
                          button: 'Check games not yet played'
                      },
                    },
                },
                buttons: {
                    startSeason: 'Start season'
                },
               
                team: {
                    summary: {
                        information: 'Information',
                        competition: 'Competition'
                    },
                    standings: {    
                        division: 'Division',
                        conference: 'Conference',
                        fields: {
                            teams: 'TEAMS',
                            w: 'W',
                            l: 'L',
                            win: 'W%',
                            gb: 'GB',
                            difference: '+/-',
                            home: 'HOME',
                            road: 'ROAD',
                            last4: 'L4',
                        }
                    }
                },
                participants: {
                    menu: 'Participants'
                },
                school: {
                    newPair: {
                        title: 'Match school',
                    },
                    editPair: {
                        title: 'Edit the school team'
                    }
                }
            }, 
        },
        stripe: {
            payment: 'Payment',
            totalAmount: {
                title: 'Total Amount',
                card: {
                    paid: 'Paid',
                    pending: 'Pending'
                }
            },
            charges: {
                title: 'Charges',
            },
        },
        stripeIncome: {
            tabs: {
                charges: 'Charges',
                payouts: 'Payouts',
            }, 
            table: {
                fee: 'Fee',
            }
        },
        stripeCharge: {
            fields: {
                id: 'Id',
                'connectedAccount' : 'Connected Account',
                'type': 'Charge Type',
                'stripeChargeId': 'Charge No.',
                'stripeFee': 'Stripe Fee',
                'applicationFee': 'Application Fee',
                'amount': 'Amount',
                'currency': 'Currency',
                'status': 'Status',
                'paymentMethod': 'Payment Method',
                'user': 'User',
                createdAt: 'Date',
                updatedAt: 'Updated at',
            },

        },
        stripeConnectedAccount: {
            state: {
                enabled: 'Enabled',
                disabled: 'Disabled'
            },
            fields: {
                id: 'Id',
                'subpropertyName': 'Subproperty name',
                'phone': 'Phone',
                'url': 'URL',
                'stripeConnectedAccountId': 'Stripe Connected Account Id',
                'country': 'Country',
                'createdRange': 'Created',
                'defaultCurrency': 'Default Currency',
                'settings': 'Settings',
                'email': 'Email',
                'address': 'Address',
                'businessType': 'Business Type',
                'productDescription': 'Product Description',
                'companyName': 'Company Name',
                'companyTaxId': 'Company Tax ID',
                'personalIdNumber': 'Personal ID Number',
                'tosAccepted': 'Accepting the Stripe Terms of Service',
                'tosAcceptance': 'Accepted on {{date}}, using IP {{ip}}',
                'inscriptionTutorConfirmed': 'Tutor confirmation',
                'mcc': 'MCC',
                'firstName': 'First Name',
                'lastName': 'Last Name',
                'birthdate': 'Birthdate',
                'verificationIdFront': 'Verification ID Document (Front)',
                'verificationIdBack': 'Verification ID Document (Back)',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            placeholders: {
                'phone': '+1-541-754-3010',
                'url': 'https://www.',
                'country': 'Select country',
                'defaultCurrency': 'Select currency',
                'email': 'email@domain.com',
                'businessType': 'Business Type',
                'productDescription': 'Product Description',
                'companyName': 'Company Name',
                'companyTaxId': 'Company Tax ID',
                'personalIdNumber': 'Personal ID Number',
                'mcc': 'MCC',
                'firstName': 'Sebastian',
                'lastName': 'Stevens',
                'birthdate': 'mm/dd/yyyy',
                'verificationIdFront': 'Photo ID (Front)',
                'verificationIdBack': 'Photo ID (Back)',
            },
            form: {
                title: {
                    company: '<strong>Company</strong> account',
                    individual: '<strong>Individual</strong> account',
                },
                subtitle: {
                    information: 'Information',
                    address: 'Address',
                    verification: 'Verification',
                }
            },
            create: {
                title: 'Create account',
                success: 'Account created successfully'
            },
            update: {
                title: 'Edit account',
                success: 'Account updated successfully'
            },
            policy: 'By clicking, you agree the <a href="https://stripe.com/connect-account/legal" target="_blank">Stripe Connected Account Agreement</a>.',
        },
        stripePerson: {
            fields: {
                id: 'ID',
                stripePersonId: 'Stripe ID',
                created: 'Created',
                name: 'Name',
                firstName: 'First Name',
                lastName: 'Last Name',
                birthdate: 'Date of birth',
                jobTitle: 'Job title',
                role: 'Roles',
                isAccountOpener: 'Representative',
                isDirector: 'Director',
                isExecutive: 'Executive',
                isOwner: 'Owner (25% or more)',
                ownershipPercentage: 'Percentage of the company',
                address: 'Address',
                ssnLast4: {
                    default: 'SSN (Last 4)',
                    US: 'SSN (Last 4)',
                    CA: 'Social Insurance Number (Last 4)',
                },
                ssnLast4Provided: {
                    default: 'SSN (Last 4)',
                    US: 'SSN (Last 4)',
                    CA: 'Social Insurance Number (Last 4)',
                },
                email: 'Email',
                phone: 'Phone',
                requirements: 'Requirements',
                verification: 'Identity verification',
                verificationIdFront: 'Photo ID (Front)',
                verificationIdBack: 'Photo ID (Back)',
                additionalDocumentFront: 'Additional Document (Front)',
                additionalDocumentBack: 'Additional Document (Back)',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
                createdRange: 'Created at',
            },
            placeholders: {
                firstName: 'Sebastian',
                lastName: 'Stevens',
                birthdate: 'yyyy-mm-dd',
                jobTitle: 'Entrepreneur',
                email: 'mail@mail.com',
                phone: '654 32 32 32',
                ownershipPercentage: '100',
                ssnLast4: 'XXXX',
                verificationIdFront: 'Photo ID (Front)',
                verificationIdBack: 'Photo ID (Back)',
                additionalDocumentFront: 'Additional Document (Front)',
                additionalDocumentBack: 'Additional Document (Back)',
            },
            validation: {
                minAge: 'Must be at least 13 years of age to use payment features.',
                accountOpener: 'A Connected Account can only have one representative.',
                maxOwnershipPercentage: 'The total combined ownership of the company would exceed 100 percent.',
                accountOpenerExecutiveOrOwner: 'The representative must also be an executive and/or owner.',
            },
            tooltips: {
                owner: 'This person owns, directly or indirectly, 25% or more of the shareholding in the company under a contract, agreement, understanding, relationship or otherwise.',
                accountOpener: 'Every account must verify one person with authority to represent the organization to Stripe.\n\nTo change the representative, you must first remove this role from the person currently marked as the representative.',
                director: 'A member of the governing board of the business who is responsible for ensuring the business meets its regulatory obligations.',
                executive: 'An executive, senior manager or someone who otherwise has significant responsibility for the control and management of the business.',
                verificationId: {
                    default: 'Requirements for verifying identity\n\nScanned copies of the front and back of the identity document:\n\n- Passport\n-  Driving licence\n- ID card\n- Resident permit ID / U.S.Green Card / North Carolina Resident ID\n- Border Crossing Card\n- Child ID card\n- NYC Card\n- U.S. visa card\n\nFiles must be in .jpeg or .png format and weigh less than 5MB. We cannot verify PDF files.\n\nFiles should be colored and rotated with the image facing up. All information should be read clearly..',
                    US: 'Requirements for verifying identity\n\nScanned copies of the front and back of the identity document:\n\n- Passport\n-  Driving licence\n- ID card\n- Resident permit ID / U.S.Green Card / North Carolina Resident ID\n- Border Crossing Card\n- Child ID card\n- NYC Card\n- U.S. visa card\n\nFiles must be in .jpeg or .png format and weigh less than 5MB. We cannot verify PDF files.\n\nFiles should be colored and rotated with the image facing up. All information should be read clearly..',
                    CA: 'Requirements for verifying identity\n\nScanned copies of the front and back of the identity document:\n- Passport\n-  Driving licence\n- ID card\n- National ID\n- Resident permit ID\n- Certificat de citoyenneté canadienne \n\nFiles must be in .jpeg or .png format and weigh less than 5MB. We cannot verify PDF files.\n\nFiles should be colored and rotated with the image facing up. All information should be read clearly..',
                    ES: 'Requirements for verifying identity\n\nScanned copies of the front and back of the identity document:\n- Passport\n-  Driving licence\n- DNI\n- Foreign Indetity Card\n\nFiles must be in .jpeg or .png format and weigh less than 5MB. We cannot verify PDF files.\n\nFiles should be colored and rotated with the image facing up. All information should be read clearly..',
                },
                additionalDocument: {
                    default: 'A document showing address, either a passport, local ID card, or utility bill from a well-known utility company.',
                },
            },
            form: {
                title: '<strong>Connected Person</strong> account',
                subtitle: {
                    information: 'Information',
                    address: 'Residential Address',
                    verification: 'ID verification',
                    additionalDocument: 'Additional document',
                }
            },
            create: {
                title: 'Create account',
                success: 'Account created successfully'
            },

            update: {
                title: 'Edit person',
                success: 'Person updated successfully'
            },
            enumerators: {
                personType: {
                    accountOpener: 'Representative',
                    director: 'Director',
                    executive: 'Executive',
                    owner: 'Owner',
                    default: 'None'
                }
            }
        },
        stripeExternalAccount: {
            fields: {
                id: 'Id',
                holderName: 'Holder name',
                holderType: 'Holder type',
                country: 'Country',
                currency: 'Currency',
                sortCode: 'Sort code',
                transitNumber: 'Transit number',
                institutionNumber: 'Institution number',
                routingNumber: 'Routing number',
                accountNumber: 'Account number',
                ibanNumber: 'IBAN',
                defaultForCurrency: 'Set as default payout method',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
            },
            placeholders: {
                holderName: 'Gabriel Moreira',
                holderType: 'Select one',
                sortCode: '12-34-56',
                transitNumber: '12345',
                institutionNumber: '123',
                routingNumber: '110000000',
                accountNumber: 'Format varies by bank',
                ibanNumber: 'IBAN',
            },
            form: {
                title: {
                    bankAccount: '<strong>Bank</strong> account',
                    card: '<strong>Debit</strong> card',
                },
                subtitle: {
                    information: 'Bank account information',
                }
            },
            create: {
                title: 'Create payout method',
                success: 'Payout method created successfully'
            },
            update: {
                title: 'Edit payout method',
                success: 'Payout method updated successfully'
            },
        },
        stripePayout: {
            fields: {
                id: 'Id',
                'created': 'Created',
                'property': 'Property',
                'stripePayoutId': 'Stripe Payout ID',
                'connectedAccount': 'Connected Account',
                'externalAccount': 'External Account',
                'amount': 'Amount',
                'arrivalDate': 'Date',
                'automatic': 'Automatic',
                'subproperty': 'Subproperty', 
                'currency': 'Currency',
                'description': 'Description',
                'method': 'Payout Method',
                'statementDescriptor': 'Statement Descriptor',
                'status': 'Status',
                'type': 'Payout Type',
                'stripeFee': 'Fee',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
            },
        },
        address: {
            fields: {
                'city': 'City',
                'townOrCity': 'Town or city',
                'country': 'Country',
                'line1': 'Address Line 1',
                'line2': 'Address Line 2',
                'zipCode': 'ZIP Code',
                'postalCode': 'Postal Code',
                'province': 'Province',
                'state': 'State',
                'stateProvinceRegion': 'State / Province / Region',
            },
            placeholders: {
                'city': 'City',
                'townOrCity': 'Town or city',
                'country': 'Country',
                'line1': 'Street, number, floor',
                'line2': 'Additional address info',
                'zipCode': '10001',
                'postalCode': '10001',
                'province': 'Province',
                'state': 'State',
                'stateProvinceRegion': 'State / Province / Region',
            },
        },
        phone: {
            fields: {
                'phone': 'Phone number',
                'prefix': 'Prefix',
                'number': 'Number',
            },
            placeholders: {
                'prefix': '+1',
                'number': '612-345-6789',
            }
        },

        school: {
            name: 'school',
            label: 'Schools',
            menu: 'Schools',
            empty: 'No schools yet',
            unmatch: 'Unmatch',
            list: {
                menu: 'School',
                title: 'School',
                multipleCategories: 'Multiple categories'
            },
            form: {
                subtitle: {
                    information: 'Information',
                    management: 'Management'
                },
                description: {
                    email: 'Add the school managers so that they receive an email and can register'
                }
            },
            create: {
                success: 'School saved successfully',
            },
            update: {
                success: 'School saved successfully',
            },
            destroy: {
                success: 'School deleted successfully',
            },
            destroyAll: {
                success: 'Familie(s) deleted successfully',
            },
            fields: {
                id: 'Id',
                'name': 'School name',
                'teams': 'Teams',
                'categories': 'Categories',
                'location': 'Location',
                'coaches': 'Managers',
                'emails': 'Emails',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                createdAtRange: 'Created at',
            },
            placeholders: {
                fillSchool: 'Find your school',
                emptySchool: 'Enter a name',
                name: 'School name',
                location: 'Location',
                email: 'name@domain.com',
            },
            new: {
                title: 'Create School',
            },
            edit: {
                title: 'Edit School',
            },
            view: {
                title: 'View School',
                fields: {
                    franchise: 'Franchise',
                    category: 'Category',
                    location: 'Location',
                    manager: 'Manager'
                }
            }
        },
        wallet: {
            payout: {
                one: 'Payout',
            },
            buttons: {
                historic: 'Historic',
                total: 'Total'
            },
            links: {
                payouts: 'See payouts',
            },
            balance: {
                title: 'Balance',
                total: 'Total:',
                available: {
                    title: 'Available',
                    tooltipCaption: 'Available money'
                },
                pending: {
                    title: 'Pending',
                    tooltipCaption: 'Pending money'
                },
                transit: {
                    title: 'In transit',
                    tooltipCaption: 'Money In transit'
                }
            },
            activity: {
                title: 'Activity',
            },
            empty: 'Empty',
            
        },
        propertyWallet: {
            title: {
                accounts: 'My accounts:',
                payout: 'Payout:',
            },
            list: {
                wallet: '{0} Wallet',
            },
            table: {
                title: 'Dashboard',
            },
        },
    },
    newsletter: {
        name: 'newsletter',
        label: 'Newsletters',
        menu: 'Newsletters',
        exporterFileName: 'newsletter_export',
        list: {
            menu: 'Newsletters',
            title: 'Newsletters',
        },
        create: {
            success: 'Newsletter saved successfully',
        },
        update: {
            success: 'Newsletter saved successfully',
        },
        destroy: {
            success: 'Newsletter deleted successfully',
        },
        destroyAll: {
            success: 'Newsletter(s) deleted successfully',
        },
        edit: {
            title: 'Edit Newsletter',
        },
        fields: {
            id: 'Id',
            'name': 'Name',
            'lastname': 'Lastname',
            'email': 'Email',
            'zipcode': 'Zipcode',
            'state': 'State',
            createdAt: 'Created at',
            updatedAt: 'Updated at',
            createdAtRange: 'Created at',
        },
        enumerators: {
            'state': {
                'Alabama': 'Alabama',
                'Alaska': 'Alaska',
                'American_Samoa': 'American_Samoa',
                'Arizona': 'Arizona',
                'Arkansas': 'Arkansas',
                'California': 'California',
                'Colorado': 'Colorado',
                'Connecticut': 'Connecticut',
                'Delaware': 'Delaware',
                'District_Of_Columbia': 'District_Of_Columbia',
                'Federated_States_Of_Micronesia': 'Federated_States_Of_Micronesia',
                'Florida': 'Florida',
                'Georgia': 'Georgia',
                'Guam': 'Guam',
                'Hawaii': 'Hawaii',
                'Idaho': 'Idaho',
                'Illinois': 'Illinois',
                'Indiana': 'Indiana',
                'Iowa': 'Iowa',
                'Kansas': 'Kansas',
                'Kentucky': 'Kentucky',
                'Louisiana': 'Louisiana',
                'Maine': 'Maine',
                'Marshall_Islands': 'Marshall_Islands',
                'Maryland': 'Maryland',
                'Massachusetts': 'Massachusetts',
                'Michigan': 'Michigan',
                'Minnesota': 'Minnesota',
                'Mississippi': 'Mississippi',
                'Missouri': 'Missouri',
                'Montana': 'Montana',
                'Nebraska': 'Nebraska',
                'Nevada': 'Nevada',
                'New_Hampshire': 'New_Hampshire',
                'New_Jersey': 'New_Jersey',
                'New_Mexico': 'New_Mexico',
                'New_York': 'New_York',
                'North_Carolina': 'North_Carolina',
                'North_Dakota': 'North_Dakota',
                'Northern_Mariana_Islands': 'Northern_Mariana_Islands',
                'Ohio': 'Ohio',
                'Oklahoma': 'Oklahoma',
                'Oregon': 'Oregon',
                'Palau': 'Palau',
                'Pennsylvania': 'Pennsylvania',
                'Puerto_Rico': 'Puerto_Rico',
                'Rhode_Island': 'Rhode_Island',
                'South_Carolina': 'South_Carolina',
                'South_Dakota': 'South_Dakota',
                'Tennessee': 'Tennessee',
                'Texas': 'Texas',
                'Utah': 'Utah',
                'Vermont': 'Vermont',
                'Virgin_Islands': 'Virgin_Islands',
                'Virginia': 'Virginia',
                'Washington': 'Washington',
                'West_Virginia': 'West_Virginia',
                'Wisconsin': 'Wisconsin',
                'Wyoming': 'Wyoming',
            },
        },
        new: {
            title: 'New Newsletter',
        },
        view: {
            title: 'View Newsletter',
        },
        importer: {
            title: 'Import Newsletters',
            fileName: 'newsletter_import_template',
            hint: 'Files/Images columns must be the URLs of the files separated by space.',
        },
    },

    comment: {
        name: 'comment',
        label: 'Comments',
        menu: 'Comments',
        exporterFileName: 'comment_export',
        list: {
            menu: 'Comments',
            title: 'Comments',
        },
        create: {
            success: 'Comment saved successfully',
        },
        update: {
            success: 'Comment saved successfully',
        },
        destroy: {
            success: 'Comment deleted successfully',
        },
        destroyAll: {
            success: 'Comment(s) deleted successfully',
        },
        edit: {
            title: 'Edit Comment',
        },
        fields: {
            id: 'Id',
            'admin': 'Owner',
            'comment': 'Comment',
            'status': 'Status',
            createdAt: 'Created at',
            updatedAt: 'Updated at',
            createdAtRange: 'Created at',
        },
        enumerators: {
            'status': {
                'publish': 'Publish',
                'draft': 'Draft',
            },
        },
        new: {
            title: 'New Comment',
        },
        view: {
            title: 'View Comment',
        },
        importer: {
            title: 'Import Comments',
            fileName: 'comment_import_template',
            hint: 'Files/Images columns must be the URLs of the files separated by space.',
        },
    },
    enumerators: {
        manageType: {
            admin: {
                label: "Admin",
                description: "Manage property",
            },
            property: {
                label: "Property",
                description: "Manage Property",
            },
            subproperty: {
                label: "Subproperty",
                description: "Manage Subproperty",
            },
            program: {
                label: "Program",
                description: "Manage Program",
            },
            subprogram: {
                label: "Subprogram",
                description: "Manage Subprogram",
            },
        },
        access: {
            public: 'Public',
            private: 'Private',
        },
        country: {
            AD: "Andorra",
            AE: "United Arab Emirates",
            AF: "Afghanistan",
            AG: "Antigua and Barbuda",
            AI: "Anguilla",
            AL: "Albania",
            AM: "Armenia",
            AO: "Angola",
            AQ: "Antarctica",
            AR: "Argentina",
            AS: "American Samoa",
            AT: "Austria",
            AU: "Australia",
            AW: "Aruba",
            AX: "Åland Islands",
            AZ: "Azerbaijan",
            BA: "Bosnia and Herzegovina",
            BB: "Barbados",
            BD: "Bangladesh",
            BE: "Belgium",
            BF: "Burkina Faso",
            BG: "Bulgaria",
            BH: "Bahrain",
            BI: "Burundi",
            BJ: "Benin",
            BL: "Saint Barthélemy",
            BM: "Bermuda",
            BN: "Brunei Darussalam",
            BO: "Bolivia (Plurinational State of)",
            BQ: "Bonaire, Sint Eustatius and Saba",
            BR: "Brazil",
            BS: "Bahamas",
            BT: "Bhutan",
            BV: "Bouvet Island",
            BW: "Botswana",
            BY: "Belarus",
            BZ: "Belize",
            CA: "Canada",
            CC: "Cocos (Keeling) Islands",
            CD: "Congo, Democratic Republic of the",
            CF: "Central African Republic",
            CG: "Congo",
            CH: "Switzerland",
            CI: "Côte d'Ivoire",
            CK: "Cook Islands",
            CL: "Chile",
            CM: "Cameroon",
            CN: "China",
            CO: "Colombia",
            CR: "Costa Rica",
            CU: "Cuba",
            CV: "Cabo Verde",
            CW: "Curaçao",
            CX: "Christmas Island",
            CY: "Cyprus",
            CZ: "Czechia",
            DE: "Germany",
            DJ: "Djibouti",
            DK: "Denmark",
            DM: "Dominica",
            DO: "Dominican Republic",
            DZ: "Algeria",
            EC: "Ecuador",
            EE: "Estonia",
            EG: "Egypt",
            EH: "Western Sahara",
            ER: "Eritrea",
            ES: "Spain",
            ET: "Ethiopia",
            FI: "Finland",
            FJ: "Fiji",
            FK: "Falkland Islands (Malvinas)",
            FM: "Micronesia (Federated States of)",
            FO: "Faroe Islands",
            FR: "France",
            GA: "Gabon",
            GB: "United Kingdom of Great Britain and Northern Ireland",
            GD: "Grenada",
            GE: "Georgia",
            GF: "French Guiana",
            GG: "Guernsey",
            GH: "Ghana",
            GI: "Gibraltar",
            GL: "Greenland",
            GM: "Gambia",
            GN: "Guinea",
            GP: "Guadeloupe",
            GQ: "Equatorial Guinea",
            GR: "Greece",
            GS: "South Georgia and the South Sandwich Islands",
            GT: "Guatemala",
            GU: "Guam",
            GW: "Guinea-Bissau",
            GY: "Guyana",
            HK: "Hong Kong",
            HM: "Heard Island and McDonald Islands",
            HN: "Honduras",
            HR: "Croatia",
            HT: "Haiti",
            HU: "Hungary",
            ID: "Indonesia",
            IE: "Ireland",
            IL: "Israel",
            IM: "Isle of Man",
            IN: "India",
            IO: "British Indian Ocean Territory",
            IQ: "Iraq",
            IR: "Iran (Islamic Republic of)",
            IS: "Iceland",
            IT: "Italy",
            JE: "Jersey",
            JM: "Jamaica",
            JO: "Jordan",
            JP: "Japan",
            KE: "Kenya",
            KG: "Kyrgyzstan",
            KH: "Cambodia",
            KI: "Kiribati",
            KM: "Comoros",
            KN: "Saint Kitts and Nevis",
            KP: "Korea (Democratic People's Republic of)",
            KR: "Korea, Republic of",
            KW: "Kuwait",
            KY: "Cayman Islands",
            KZ: "Kazakhstan",
            LA: "Lao People's Democratic Republic",
            LB: "Lebanon",
            LC: "Saint Lucia",
            LI: "Liechtenstein",
            LK: "Sri Lanka",
            LR: "Liberia",
            LS: "Lesotho",
            LT: "Lithuania",
            LU: "Luxembourg",
            LV: "Latvia",
            LY: "Libya",
            MA: "Morocco",
            MC: "Monaco",
            MD: "Moldova, Republic of",
            ME: "Montenegro",
            MF: "Saint Martin (French part)",
            MG: "Madagascar",
            MH: "Marshall Islands",
            MK: "North Macedonia",
            ML: "Mali",
            MM: "Myanmar",
            MN: "Mongolia",
            MO: "Macao",
            MP: "Northern Mariana Islands",
            MQ: "Martinique",
            MR: "Mauritania",
            MS: "Montserrat",
            MT: "Malta",
            MU: "Mauritius",
            MV: "Maldives",
            MW: "Malawi",
            MX: "Mexico",
            MY: "Malaysia",
            MZ: "Mozambique",
            NA: "Namibia",
            NC: "New Caledonia",
            NE: "Niger",
            NF: "Norfolk Island",
            NG: "Nigeria",
            NI: "Nicaragua",
            NL: "Netherlands",
            NO: "Norway",
            NP: "Nepal",
            NR: "Nauru",
            NU: "Niue",
            NZ: "New Zealand",
            OM: "Oman",
            PA: "Panama",
            PE: "Peru",
            PF: "French Polynesia",
            PG: "Papua New Guinea",
            PH: "Philippines",
            PK: "Pakistan",
            PL: "Poland",
            PM: "Saint Pierre and Miquelon",
            PN: "Pitcairn",
            PR: "Puerto Rico",
            PS: "Palestine, State of",
            PT: "Portugal",
            PW: "Palau",
            PY: "Paraguay",
            QA: "Qatar",
            RE: "Réunion",
            RO: "Romania",
            RS: "Serbia",
            RU: "Russian Federation",
            RW: "Rwanda",
            SA: "Saudi Arabia",
            SB: "Solomon Islands",
            SC: "Seychelles",
            SD: "Sudan",
            SE: "Sweden",
            SG: "Singapore",
            SH: "Saint Helena, Ascension and Tristan da Cunha",
            SI: "Slovenia",
            SJ: "Svalbard and Jan Mayen",
            SK: "Slovakia",
            SL: "Sierra Leone",
            SM: "San Marino",
            SN: "Senegal",
            SO: "Somalia",
            SR: "Suriname",
            SS: "South Sudan",
            ST: "Sao Tome and Principe",
            SV: "El Salvador",
            SX: "Sint Maarten (Dutch part)",
            SY: "Syrian Arab Republic",
            SZ: "Eswatini",
            TC: "Turks and Caicos Islands",
            TD: "Chad",
            TF: "French Southern Territories",
            TG: "Togo",
            TH: "Thailand",
            TJ: "Tajikistan",
            TK: "Tokelau",
            TL: "Timor-Leste",
            TM: "Turkmenistan",
            TN: "Tunisia",
            TO: "Tonga",
            TR: "Turkey",
            TT: "Trinidad and Tobago",
            TV: "Tuvalu",
            TW: "Taiwan, Province of China",
            TZ: "Tanzania, United Republic of",
            UA: "Ukraine",
            UG: "Uganda",
            UM: "United States Minor Outlying Islands",
            US: "United States of America",
            UY: "Uruguay",
            UZ: "Uzbekistan",
            VA: "Holy See",
            VC: "Saint Vincent and the Grenadines",
            VE: "Venezuela (Bolivarian Republic of)",
            VG: "Virgin Islands (British)",
            VI: "Virgin Islands (U.S.)",
            VN: "Viet Nam",
            VU: "Vanuatu",
            WF: "Wallis and Futuna",
            WS: "Samoa",
            YE: "Yemen",
            YT: "Mayotte",
            ZA: "South Africa",
            ZM: "Zambia",
            ZW: "Zimbabwe",
        },
        stateProvince: {
            CA: {
                'AB': 'Alberta',
                'BC': 'British Columbia',
                'MB': 'Manitoba',
                'NB': 'New Brunswick',
                'NT': 'Northwest Territories',
                'NL': 'Newfoundland and Labrador',
                'NS': 'Nova Scotia',
                'NU': 'Nunavut',
                'ON': 'Ontario',
                'PE': 'Prince Edward Island',
                'QC': 'Quebec',
                'SK': 'Saskatchewan',
                'YT': 'Yukon',
            },
            ES: {
                'C': 'La Coruña',
                'VI': 'Álava',
                'AB': 'Albacete',
                'A': 'Alicante',
                'AL': 'Almería',
                'O': 'Asturias',
                'AV': 'Ávila',
                'BA': 'Badajoz',
                'PM': 'Baleares',
                'B': 'Barcelona',
                'BI': 'Bizkaia',
                'BU': 'Burgos',
                'CC': 'Cáceres',
                'CA': 'Cádiz',
                'S': 'Cantabria',
                'CS': 'Castellón',
                'CE': 'Ceuta',
                'CR': 'Ciudad Real',
                'CO': 'Córdoba',
                'CU': 'Cuenca',
                'SS': 'Gipuzkoa',
                'GI': 'Gerona',
                'GR': 'Granada',
                'GU': 'Guadalajara',
                'H': 'Huelva',
                'HU': 'Huesca',
                'J': 'Jaén',
                'LO': 'La Rioja',
                'GC': 'Las Palmas',
                'LE': 'León',
                'L': 'Lérida',
                'LU': 'Lugo',
                'M': 'Madrid',
                'MA': 'Málaga',
                'ML': 'Melilla',
                'MU': 'Murcia',
                'NA': 'Navarra',
                'OR': 'Orense',
                'P': 'Palencia',
                'PO': 'Pontevedra',
                'SA': 'Salamanca',
                'TF': 'Santa Cruz de Tenerife',
                'SG': 'Segovia',
                'SE': 'Sevilla',
                'SO': 'Soria',
                'T': 'Tarragona',
                'TE': 'Teruel',
                'TO': 'Toledo',
                'V': 'Valencia',
                'VA': 'Valladolid',
                'ZA': 'Zamora',
                'Z': 'Zaragoza',
            },
            US: {
                'AL': 'Alabama',
                'AK': 'Alaska',
                'AZ': 'Arizona',
                'AR': 'Arkansas',
                'CA': 'California',
                'CO': 'Colorado',
                'CT': 'Connecticut',
                'DE': 'Delaware',
                'FL': 'Florida',
                'GA': 'Georgia',
                'HI': 'Hawaii',
                'ID': 'Idaho',
                'IL': 'Illinois',
                'IN': 'Indiana',
                'IA': 'Iowa',
                'KS': 'Kansas',
                'KY': 'Kentucky',
                'LA': 'Louisiana',
                'ME': 'Maine',
                'MD': 'Maryland',
                'MA': 'Massachusetts',
                'MI': 'Michigan',
                'MN': 'Minnesota',
                'MS': 'Mississippi',
                'MO': 'Missouri',
                'MT': 'Montana',
                'NE': 'Nebraska',
                'NV': 'Nevada',
                'NH': 'New Hampshire',
                'NJ': 'New Jersey',
                'NM': 'New Mexico',
                'NY': 'New York',
                'NC': 'North Carolina',
                'ND': 'North Dakota',
                'OH': 'Ohio',
                'OK': 'Oklahoma',
                'OR': 'Oregon',
                'PA': 'Pennsylvania',
                'RI': 'Rhode Island',
                'SC': 'South Carolina',
                'SD': 'South Dakota',
                'TN': 'Tennessee',
                'TX': 'Texas',
                'UT': 'Utah',
                'VT': 'Vermont',
                'VA': 'Virginia',
                'WA': 'Washington',
                'WV': 'West Virginia',
                'WI': 'Wisconsin',
                'WY': 'Wyoming',
            },
        },
        soccerFormat: {
            'f7': 'Soccer 7',
            'f11': 'Soccer 11',
        },
        clubType: {
            federated: 'Federation in Spain',
            federatedForeign: 'Federation outside of Spain',
            nonFederated: 'Not a part of a federation',
            academy: 'Academy',
            nationalTeam: 'Select team',
            other: 'Other',
        },
        clubFederation: {
            'AN': 'Andalusia',
            'AR': 'Aragon',
            'AS': 'Asturias, Principality de',
            'CN': 'Canary Islands',
            'CB': 'Cantabria',
            'CL': 'Castile and León	',
            'CM': 'Castile-La Mancha',
            'CT': 'Catalonia',
            'CE': 'Ceuta',
            'EX': 'Extremadura',
            'GA': 'Galicia',
            'IB': 'Balearic Islands',
            'RI': 'La Rioja',
            'MD': 'Madrid, Community of',
            'ML': 'Melilla',
            'MC': 'Murcia, Region of',
            'NC': 'Navarra, Chartered Community of',
            'PV': 'Basque Country',
            'VC': 'Valencian, Community',
        },
        clubKitPieceType: {
            solid: 'Solid',
            striped: 'Striped',
            checkered: 'Checkered',
            band: 'Band',
        },
        mcc: {
            '7032': '(7032) Sporting / Recreation Camps',
            '7941': '(7941) Sports Clubs / Fields',
            '8211': '(8211) Elementary, Secondary Schools',
            '8220': '(8220) Colleges, Universities',
            '8299': '(8299) Educational Services',
            '8699': '(8699) Membership Organizations',
        },
        currency: {
            'aed': 'AED - United Arab Emirates dirham',
            'afn': 'AFN - Afghan afghani',
            'all': 'ALL - Albanian lek',
            'amd': 'AMD - Armenian dram',
            'ang': 'ANG - Netherlands Antillean guilder',
            'aoa': 'AOA - Angolan kwanza',
            'ars': 'ARS - Argentine peso',
            'aud': 'AUD - Australian dollar',
            'awg': 'AWG - Aruban florin',
            'azn': 'AZN - Azerbaijani manat',
            'bam': 'BAM - Bosnia and Herzegovina convertible mark',
            'bbd': 'BBD - Barbados dollar',
            'bdt': 'BDT - Bangladeshi taka',
            'bgn': 'BGN - Bulgarian lev',
            'bhd': 'BHD - Bahraini dinar',
            'bif': 'BIF - Burundian franc',
            'bmd': 'BMD - Bermudian dollar',
            'bnd': 'BND - Brunei dollar',
            'bob': 'BOB - Boliviano',
            'bov': 'BOV - Bolivian Mvdol',
            'brl': 'BRL - Brazilian real',
            'bsd': 'BSD - Bahamian dollar',
            'btn': 'BTN - Bhutanese ngultrum',
            'bwp': 'BWP - Botswana pula',
            'byn': 'BYN - Belarusian ruble',
            'bzd': 'BZD - Belize dollar',
            'cad': 'CAD - Canadian dollar',
            'cdf': 'CDF - Congolese franc',
            'che': 'CHE - WIR Euro',
            'chf': 'CHF - Swiss franc',
            'chw': 'CHW - WIR Franc',
            'clf': 'CLF - Unidad de Fomento',
            'clp': 'CLP - Chilean peso',
            'cny': 'CNY - Renminbi (Chinese) yuan',
            'cop': 'COP - Colombian peso',
            'cou': 'COU - Unidad de Valor Real (UVR)',
            'crc': 'CRC - Costa Rican colon',
            'cuc': 'CUC - Cuban convertible peso',
            'cup': 'CUP - Cuban peso',
            'cve': 'CVE - Cape Verdean escudo',
            'czk': 'CZK - Czech koruna',
            'djf': 'DJF - Djiboutian franc',
            'dkk': 'DKK - Danish krone',
            'dop': 'DOP - Dominican peso',
            'dzd': 'DZD - Algerian dinar',
            'egp': 'EGP - Egyptian pound',
            'ern': 'ERN - Eritrean nakfa',
            'etb': 'ETB - Ethiopian birr',
            'eur': 'EUR - Euro',
            'fjd': 'FJD - Fiji dollar',
            'fkp': 'FKP - Falkland Islands pound',
            'gbp': 'GBP - Pound sterling',
            'gel': 'GEL - Georgian lari',
            'ghs': 'GHS - Ghanaian cedi',
            'gip': 'GIP - Gibraltar pound',
            'gmd': 'GMD - Gambian dalasi',
            'gnf': 'GNF - Guinean franc',
            'gtq': 'GTQ - Guatemalan quetzal',
            'gyd': 'GYD - Guyanese dollar',
            'hkd': 'HKD - Hong Kong dollar',
            'hnl': 'HNL - Honduran lempira',
            'hrk': 'HRK - Croatian kuna',
            'htg': 'HTG - Haitian gourde',
            'huf': 'HUF - Hungarian forint',
            'idr': 'IDR - Indonesian rupiah',
            'ils': 'ILS - Israeli new shekel',
            'inr': 'INR - Indian rupee',
            'iqd': 'IQD - Iraqi dinar',
            'irr': 'IRR - Iranian rial',
            'isk': 'ISK - Icelandic króna',
            'jmd': 'JMD - Jamaican dollar',
            'jod': 'JOD - Jordanian dinar',
            'jpy': 'JPY - Japanese yen',
            'kes': 'KES - Kenyan shilling',
            'kgs': 'KGS - Kyrgyzstani som',
            'khr': 'KHR - Cambodian riel',
            'kmf': 'KMF - Comoro franc',
            'kpw': 'KPW - North Korean won',
            'krw': 'KRW - South Korean won',
            'kwd': 'KWD - Kuwaiti dinar',
            'kyd': 'KYD - Cayman Islands dollar',
            'kzt': 'KZT - Kazakhstani tenge',
            'lak': 'LAK - Lao kip',
            'lbp': 'LBP - Lebanese pound',
            'lkr': 'LKR - Sri Lankan rupee',
            'lrd': 'LRD - Liberian dollar',
            'lsl': 'LSL - Lesotho loti',
            'lyd': 'LYD - Libyan dinar',
            'mad': 'MAD - Moroccan dirham',
            'mdl': 'MDL - Moldovan leu',
            'mga': 'MGA - Malagasy ariary',
            'mkd': 'MKD - Macedonian denar',
            'mmk': 'MMK - Myanmar kyat',
            'mnt': 'MNT - Mongolian tögrög',
            'mop': 'MOP - Macanese pataca',
            'mru': 'MRU - Mauritanian ouguiya',
            'mur': 'MUR - Mauritian rupee',
            'mvr': 'MVR - Maldivian rufiyaa',
            'mwk': 'MWK - Malawian kwacha',
            'mxn': 'MXN - Mexican peso',
            'mxv': 'MXV - Mexican Unidad de Inversion (UDI)',
            'myr': 'MYR - Malaysian ringgit',
            'mzn': 'MZN - Mozambican metical',
            'nad': 'NAD - Namibian dollar',
            'ngn': 'NGN - Nigerian naira',
            'nio': 'NIO - Nicaraguan córdoba',
            'nok': 'NOK - Norwegian krone',
            'npr': 'NPR - Nepalese rupee',
            'nzd': 'NZD - New Zealand dollar',
            'omr': 'OMR - Omani rial',
            'pab': 'PAB - Panamanian balboa',
            'pen': 'PEN - Peruvian sol',
            'pgk': 'PGK - Papua New Guinean kina',
            'php': 'PHP - Philippine peso',
            'pkr': 'PKR - Pakistani rupee',
            'pln': 'PLN - Polish złoty',
            'pyg': 'PYG - Paraguayan guaraní',
            'qar': 'QAR - Qatari riyal',
            'ron': 'RON - Romanian leu',
            'rsd': 'RSD - Serbian dinar',
            'rub': 'RUB - Russian ruble',
            'rwf': 'RWF - Rwandan franc',
            'sar': 'SAR - Saudi riyal',
            'sbd': 'SBD - Solomon Islands dollar',
            'scr': 'SCR - Seychelles rupee',
            'sdg': 'SDG - Sudanese pound',
            'sek': 'SEK - Swedish krona/kronor',
            'sgd': 'SGD - Singapore dollar',
            'shp': 'SHP - Saint Helena pound',
            'sll': 'SLL - Sierra Leonean leone',
            'sos': 'SOS - Somali shilling',
            'srd': 'SRD - Surinamese dollar',
            'ssp': 'SSP - South Sudanese pound',
            'stn': 'STN - São Tomé and Príncipe dobra',
            'svc': 'SVC - Salvadoran colón',
            'syp': 'SYP - Syrian pound',
            'szl': 'SZL - Swazi lilangeni',
            'thb': 'THB - Thai baht',
            'tjs': 'TJS - Tajikistani somoni',
            'tmt': 'TMT - Turkmenistan manat',
            'tnd': 'TND - Tunisian dinar',
            'top': 'TOP - Tongan paʻanga',
            'try': 'TRY - Turkish lira',
            'ttd': 'TTD - Trinidad and Tobago dollar',
            'twd': 'TWD - New Taiwan dollar',
            'tzs': 'TZS - Tanzanian shilling',
            'uah': 'UAH - Ukrainian hryvnia',
            'ugx': 'UGX - Ugandan shilling',
            'usd': 'USD - United States dollar',
            'usn': 'USN - United States dollar (next day)',
            'uyi': 'UYI - Uruguay Peso en Unidades Indexadas (URUIURUI)',
            'uyu': 'UYU - Uruguayan peso',
            'uyw': 'UYW - Unidad previsional',
            'uzs': 'UZS - Uzbekistan som',
            'ves': 'VES - Venezuelan bolívar soberano',
            'vnd': 'VND - Vietnamese đồng',
            'vuv': 'VUV - Vanuatu vatu',
            'wst': 'WST - Samoan tala',
            'xaf': 'XAF - CFA franc BEAC',
            'xag': 'XAG - Silver (one troy ounce)',
            'xau': 'XAU - Gold (one troy ounce)',
            'xba': 'XBA - European Composite Unit (EURCO)',
            'xbb': 'XBB - European Monetary Unit (E.M.U.-6)',
            'xbc': 'XBC - European Unit of Account 9 (E.U.A.-9)',
            'xbd': 'XBD - European Unit of Account 17 (E.U.A.-17)',
            'xcd': 'XCD - East Caribbean dollar',
            'xdr': 'XDR - Special drawing rights',
            'xof': 'XOF - CFA franc BCEAO',
            'xpd': 'XPD - Palladium (one troy ounce)',
            'xpf': 'XPF - CFP franc (franc Pacifique)',
            'xpt': 'XPT - Platinum (one troy ounce)',
            'xsu': 'XSU - SUCRE',
            'xts': 'XTS - Code reserved for testing',
            'xua': 'XUA - ADB Unit of Account',
            'xxx': 'XXX - No currency',
            'yer': 'YER - Yemeni rial',
            'zar': 'ZAR - South African rand',
            'zmw': 'ZMW - Zambian kwacha',
            'zwl': 'ZWL - Zimbabwean dollar',
        },
        phoneAdditionalCountries: {
            'CY-N': 'Cyprus - North',
            'CY-S': 'Cyprus - South',
            'YE-N': 'Yemen - North',
            'YE-S': 'Yemen - South',
        },
        businessType: {
            individual: 'Individual',
            company: 'Company',
        },
        subpropertyStatus: {
            enabled: "Enabled",
            disabled: "Disabled"
        },
        gender: {
            'male': 'Boys',
            'female': 'Girls',
            'mixed': 'Boys & Girls',
        },
        genderBinary: {
            'male': 'Male',
            'female': 'Female',
        },
        programType: {
            'all': 'All',
            'club': 'Club',
            'school': 'School',
            'campclinics': 'Camp & Clinics',
            'league': 'League',
            'tournament': 'Tournament',
        },
        programStatus: {
            "draft": "Draft",
            "published": "Published",
            "regOpened": "Registration open",
            "regClosed": "Registration closed",
            "archived": "Archived"
        },
        propertyType: {
            'academyclub': 'Academy & Club',
            'league': 'League',
            'tournament': 'Tournament',
            'nba': 'NBA',
        },
        propertyStatus: {
            enabled: "Enabled",
            disabled: "Disabled"
        },
        sport: {
            'basketball': 'Basketball',
            'soccer': 'Soccer',
        },
        subprogramStatus: {
            "draft": "Draft",
            "published": "Published",
            "comingSoon": "Registration coming soon",
            "regOpened": "Registration open",
            "regClosed": "Registration closed",
            "archived": "Archived",
        },
        inscriptionStatus: {
            'all': 'All',
            'pendingApproval': "Pending approval",
            'onWaitingList': "Waiting list",
            'onTryout': "On tryout",
            'approved': "Approved",
            'pendingPayment': "Pending payment",
            'paid': "Paid",
            'reject': "Rejected",
        },
        payoutObjectType: {
            bank_account: 'Bank account',
            card: 'Card'
        },
        payoutStatus: {
            paid: "Paid",
            pending: "Pending",
            in_transit: "In transit",
            canceled: "Canceled",
            failed: "Failed",
        },
        chargeType: {
            oneTime: 'One Time',
            installment: 'Installment',
            subscription: 'Subscription',
        },
        chargeStatus: {
            succeeded: 'Succeeded',
            pending: 'Pending',
            failed: 'Failed',
        },
        stripePayoutsScheduleInterval: {
            daily: 'Each day',
            weekly: 'Each week',
            monthly: 'Each month'
        },
        weekDay: {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday'
        },
        monthDay: {
            1: '1st',
            2: '2nd',
            3: '3rd',
            4: '4th',
            5: '5th',
            6: '6th',
            7: '7th',
            8: '8th',
            9: '9th',
            10: '10th',
            11: '11th',
            12: '12th',
            13: '13th',
            14: '14th',
            15: '15th',
            16: '16th',
            17: '17th',
            18: '18th',
            19: '19th',
            20: '20th',
            21: '21st',
            22: '22nd',
            23: '23rd',
            24: '24th',
            25: '25th',
            26: '26th',
            27: '27th',
            28: '28th',
            29: '29th',
            30: '30th',
            31: '31st',
        },
        stripePersonVerification: {
            unverified: "Unverified",
            pending: "Pending",
            verified: "Verified",
            failed: "Failed",
            incomplete: "Incomplete",
        },
        externalAccountStatus: {
            new: 'New',
            validated: 'Validated',
            verified: 'Verified',
            verification_failed: 'Verification Failed',
            errored: 'Errored',
        },
        coachType: {
            coachHead: 'Head Coach',
            coachDirector: 'Director of Coaching',
            coach: 'Coach',
            coachAssistant: 'Coach Assistant',
            schoolManager: 'School Manager',
            teamManager: 'Team Manager'
        },
        birthdateType: {
            year: 'By year',
            monthAndYear: 'By month and year',
        },
        dateFormat: {
            'dd/MM/yyyy': 'dd/mm/yyyy',
            'MM/dd/yyyy': 'mm/dd/yyyy',
        },
        timeFormat: {
            'hh:mm a': '12h (AM/PM)',
            'HH:mm': '24h',
        },
        gameStatus: {
            'toPlay': 'To play',
            'toBeConfirmed': 'To be confirmed',
            'disputedResult': 'Dispute result',
            'played': 'Played'
        },
        gameType: {
            'groups': 'Groups',
            'playoffs': 'Playoffs',
        },
    },
    auth: {
        profile: {
            title: 'Edit Profile',
            success: 'Profile updated successfully',
        },
        createAnAccount: 'Create an account',
        createYourAccount: 'Create your account',
        rememberMe: 'Remember me',
        noAccountYet: 'Don\'t have an account yet?',
        forgotPassword: {
            message: 'Forgot your password?',
            error: {
                'email/unknown': 'This email address is not registered',
            },
        },
        login: 'Sign in',
        signin: 'Sign in',
        signup: 'Sign up',
        signupText: 'Complete your profile',
        signout: 'Sign out',
        alreadyHaveAnAccount: 'Already have an account?',
        signinWithAnotherAccount: 'Sign in with another account',
        emailUnverified: {
            welcome: `Welcome to <strong>{0}</strong>`,
            message: `Please confirm your email at <strong>{0}</strong> to continue.`,
            submit: `Send Verification Email`,
        },
        emptyPermissions: {
            title: `You're already part of <strong>OWQLO! </strong>`,
            message: `Download the app and start enjoying.`,
        },
        dynamicLink: {
            title: `You are almost in <strong>OWQLO!</strong>`,
            first: 'Open this link again from your phone',
            second: 'Download the app',
            third: 'Enjoy our platform!'
        }, 
        passwordResetEmail: {
            message: 'Reset password',
            error: `Email not recognized`,
            success: {
                title: 'Email sent',
                message: 'We have sent you an email with the steps to follow to reset your password.',
                buttonCaption: 'Go to home',
            },
        },
        passwordReset: {
            title: 'Password successfully reset',
            first: 'Open the app from your phone',
            second: 'Simply log in with your new password',
            third: 'Enjoy discovering our platform!'
        },
        emailVerification: {
            title: 'Email successfully verified',
            first: 'Open the app from your phone',
            second: 'Simply log in',
            third: 'Enjoy discovering our platform!'
        },
        emailAddressVerificationEmail: {
            error: `Email not recognized`,
        },
        verificationEmailSuccess: `Verification email sent successfully`,
        passwordResetEmailSuccess: `Password reset email sent successfully`,
        passwordResetSuccess: `Password changed successfully`,
        verifyEmail: {
            success: 'Email successfully verified',
            message: 'Just a moment, your email is being verified...',
        },
        passwordAgain: 'Please input the password again',
        passwordNotMatch: 'The password don\'t match!',
        fields: {
          email: 'Email',
          password: 'Password',
          confirmPassword: 'Confirm password',
          rememberMe: 'Remember me'
        }
    },

    roles: {
        admin: {
            label: 'Owner',
            description: 'Full access to all resources',
        },
        propertyManager: {
            label: "Property Manager",
            description: "Full access to all resources of property",
        },
        subpropertyManager: {
            label: "Subproperty Manager",
            description: "Full access to all resources of subproperty",
        },
        programManager: {
            label: "Program Manager",
            description: "Full access to all resources of program",
        },
        subprogramManager: {
            label: "Subprogram Manager",
            description: "Full access to all resources of subprogram",
        },
        editor: {
            label: 'Editor',
            description: 'Edit access to all resources',
        },
        viewer: {
            label: 'Viewer',
            description: 'View access to all resources',
        },
        auditLogViewer: {
            label: 'Audit Log Viewer',
            description: 'Access to view audit logs',
        },
        iamSecurityReviewer: {
            label: 'Security Reviewer',
            description: `Full access to manage users roles`,
        },
        entityEditor: {
            label: 'Entity Editor',
            description: 'Edit access to all entities',
        },
        entityViewer: {
            label: 'Entity Viewer',
            description: 'View access to all entities',
        },
        academyEditor: {
            label: 'Academy Editor',
            description: 'Edit access to academies',
        },
        academyViewer: {
            label: 'Academy Viewer',
            description: 'View access to academies',
        },
        playerEditor: {
            label: 'Player Editor',
            description: 'Edit access to players',
        },
        playerViewer: {
            label: 'Player Viewer',
            description: 'View access to players',
        },
        propertySettingEditor: {
            label: 'PropertySetting Editor',
            description: 'Edit access to propertySettings',
        },
        propertySettingViewer: {
            label: 'PropertySetting Viewer',
            description: 'View access to propertySettings',
        },
        coachEditor: {
            label: 'Coach Editor',
            description: 'Edit access to coaches',
        },
        coachViewer: {
            label: 'Coach Viewer',
            description: 'View access to coaches',
        },
        parentEditor: {
            label: 'Parent Editor',
            description: 'Edit access to parents',
        },
        parentViewer: {
            label: 'Parent Viewer',
            description: 'View access to parents',
        },
        newsEditor: {
            label: 'News Editor',
            description: 'Edit access to news',
        },
        newsViewer: {
            label: 'News Viewer',
            description: 'View access to news',
        },
        trainingEditor: {
            label: 'Training Editor',
            description: 'Edit access to trainings',
        },
        trainingViewer: {
            label: 'Training Viewer',
            description: 'View access to trainings',
        },
        gameEditor: {
            label: 'Game Editor',
            description: 'Edit access to games',
        },
        gameViewer: {
            label: 'Game Viewer',
            description: 'View access to games',
        },
        eventEditor: {
            label: 'Event Editor',
            description: 'Edit access to events',
        },
        eventViewer: {
            label: 'Event Viewer',
            description: 'View access to events',
        },
        teamEditor: {
            label: 'Team Editor',
            description: 'Edit access to teams',
        },
        teamViewer: {
            label: 'Team Viewer',
            description: 'View access to teams',
        },
        positionEditor: {
            label: 'Position Editor',
            description: 'Edit access to positions',
        },
        positionViewer: {
            label: 'Position Viewer',
            description: 'View access to positions',
        },
        fanEditor: {
            label: 'Fan Editor',
            description: 'Edit access to fans',
        },
        fanViewer: {
            label: 'Fan Viewer',
            description: 'View access to fans',
        },
        sheetEventEditor: {
            label: 'SheetEvent Editor',
            description: 'Edit access to sheetEvents',
        },
        sheetEventViewer: {
            label: 'SheetEvent Viewer',
            description: 'View access to sheetEvents',
        },
        siteEditor: {
            label: 'Site Editor',
            description: 'Edit access to sites',
        },
        siteViewer: {
            label: 'Site Viewer',
            description: 'View access to sites',
        },
        clubEditor: {
            label: 'Club Editor',
            description: 'Edit access to clubs',
        },
        clubViewer: {
            label: 'Club Viewer',
            description: 'View access to clubs',
        },
        serviceEditor: {
            label: 'Service Editor',
            description: 'Edit access to services',
        },
        serviceViewer: {
            label: 'Service Viewer',
            description: 'View access to services',
        },
        propertyEditor: {
            label: 'Property Editor',
            description: 'Edit access to properties',
        },
        propertyViewer: {
            label: 'Property Viewer',
            description: 'View access to properties',
        },
        categoryEditor: {
            label: 'Category Editor',
            description: 'Edit access to categories',
        },
        categoryViewer: {
            label: 'Category Viewer',
            description: 'View access to categories',
        },
        programEditor: {
            label: 'Program Editor',
            description: 'Edit access to programs',
        },
        programViewer: {
            label: 'Program Viewer',
            description: 'View access to programs',
        },
        subprogramEditor: {
            label: 'Subprogram Editor',
            description: 'Edit access to subprograms',
        },
        subprogramViewer: {
            label: 'Subprogram Viewer',
            description: 'View access to subprograms',
        },
    },

    programs: {
        tournament: {
            label: 'Tournament',
            description: 'Tournament description',
            new: 'Create Tournament',
            empty: 'No tournaments yet',
        },
        club: {
            label: 'Club',
            description: 'Academy description',
            new: 'Create Club',
            empty: 'No clubs yet',
        },
        school: {
            label: 'School',
            description: 'Camp description',
            new: 'Create School',
            empty: 'No schools yet',
        },
        campclinics: {
            label: 'Camp & Clinics',
            description: 'Class description',
            new: 'Create Camp & Clinics',
            empty: 'No camp & clinics yet',
        },
        league: {
            label: 'League',
            menu: 'Leagues',
            description: 'League description',
            new: 'Create League',
            edit: 'Edit League',
            empty: 'No leagues yet',
        },
    },

    iam: {
        title: 'User management',
        menu: 'User management',
        disable: 'Disable',
        disabled: 'Disabled',
        enabled: 'Enabled',
        enable: 'Enable',
        doEnableSuccess: 'User enabled successfully',
        doDisableSuccess: 'User disabled successfully',
        doDisableAllSuccess: 'User(s) disabled successfully',
        doEnableAllSuccess: 'User(s) enabled successfully',
        doAddSuccess: 'User(s) saved successfully',
        doUpdateSuccess: 'User saved successfully',
        viewBy: 'View By',
        users: {
            name: 'users',
            label: 'Users',
            exporterFileName: 'users_export',
            doRemoveAllSelectedSuccess: 'Permissions removed successfully',
        },
        managers: {
            empty: 'No managers yet',
        },
        roles: {
            label: 'Roles',
            doRemoveAllSelectedSuccess: 'Permissions removed successfully',
        },

        edit: {
            title: 'Edit User',
        },
        new: {
            title: 'Create User',
            emailsHint: 'Separate multiple email addresses using the comma character.',
        },
        newManager: {
            title: 'Create Manager'
        },
        view: {
            title: 'View User',
            activity: 'Activity',
        },
        importer: {
            title: 'Import Users',
            fileName: 'users_import_template',
            hint: 'Files/Images columns must be the URLs of the files separated by space. Relationships must be the ID of the referenced records separated by space. Roles must be the role ids separated by space.',
        },
        errors: {
            userAlreadyExists: 'User with this email already exists',
            userNotFound: 'User not found',
            emailNotFound: 'Email does not exist',
            disablingHimself: `You can't disabled yourself`,
            revokingOwnPermission: `You can't revoke your own admin permission`,
        },
        placeholders: {
            roles: 'Select one...',
            email: 'email@domain.com'
        }
    },

    staff: {
        title: 'Staff',
        menu: 'Staff',
        tabs: {
            managers: 'Managers',
            coaches: 'Coaches'
        }
    },

    user: {
        fields: {
            id: 'Id',
            authenticationUid: 'Authentication Uid',
            avatars: 'Profile picture',
            email: 'Email',
            emails: 'Email(s)',
            fullName: 'Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            gender: 'Gender',
            birthdate: 'Birth Date',
            status: 'Status',
            disabled: 'Disabled',
            phoneNumber: 'Phone Number',
            role: 'Role',
            lastLogin: 'Last Login',
            createdAt: 'Created at',
            updatedAt: 'Updated at',
            roleUser: 'Role/User',
            roles: 'Roles',
            manageType: 'Manage type',
            admin: 'Admin',
            property: 'Property',
            subproperty: 'Subproperty',
            program: 'Program',
            subprogram: 'Subprogram',
            createdAtRange: 'Created at',
            password: 'Password',
            confirmPassword: {
                label: 'Confirm password',
                validation: {
                    notEqual: 'Passwords do not match',
                },
            },
            rememberMe: 'Remember me',
            tosAccepted: {
                label: 'I have read and agree to ${linkTerms} and ${linkPrivacy}',
                linkCaptionPrivacy: 'Privacy Policy',
                linkHrefPrivacy: 'https://owqlo.com/privacy-policy/',
                linkCaptionTerms: 'Terms and Conditions',
                linkHrefTerms: 'https://owqlo.com/terms-and-conditions/',
                validation: 'It is required to read and agree to the conditions above',
            },
            inscriptionTutorConfirmed: {
                label: 'I confirm I\'m parent of the players registered.',
                validation: 'It is required to agree to the conditions above',
            },
            'identDoc': 'ID Number',
        },
        placeholders: {
            firstName: 'Matthew',
            lastName: 'Williams',
            gender: 'Select one',
            birthdate: 'yyyy-mm-dd',
            phoneNumber: '+1-541-754-1010',
            email: 'email@domain.com',
            password: '********',
            confirmPassword: '********',
        },
        form: {
            subtitle: {
                parentInfo: 'Parent info',
                parentAddress: 'Parent address',
            },
            tooltip: {
                emailDisabled: 'For privacy reasons we do not allow you to change the email address ',            }
        },
        enabled: 'Authorized',
        disabled: 'Unauthorized',
        validations: {
            email: 'Email is invalid',
            url: 'URL is invalid',
            phone: 'Phone number is invalid',
        },
    },

    auditLog: {
        menu: 'Audit Logs',
        title: 'Audit Logs',
        exporterFileName: 'audit_log_export',
        entityNamesHint: 'Separate multiple entities using the comma character.',
        fields: {
            id: 'Id',
            timestampRange: 'Period',
            entityName: 'Entity',
            entityNames: 'Entities',
            entityId: 'Entity ID',
            action: 'Action',
            values: 'Values',
            timestamp: 'Date',
            createdByEmail: 'User Email',
        },
    },
    adminSettings: {
        title: 'Settings',
        menu: 'Settings',
        save: {
            success: 'Settings saved successfully. The page will reload in {0} seconds for changes to take effect.',
        },
        fields: {
            theme: 'Theme',
        },
        colors: {
            default: 'Default',
            cyan: 'Cyan',
            'geek-blue': 'Geek Blue',
            gold: 'Gold',
            lime: 'Lime',
            magenta: 'Magenta',
            orange: 'Orange',
            'polar-green': 'Polar Green',
            purple: 'Purple',
            red: 'Red',
            volcano: 'Volcano',
            yellow: 'Yellow',
        },
    },

    propertySettings: {
        title: 'Property settings',
        menu: 'Settings',
    },

    subpropertySettings: {
        title: 'Subproperty settings',
        menu: 'Settings',
        information: 'Here would go a copy that is yet to be defined. To explain that these fields are configurable by the Admin, that is, they are creating default information.',
        program: {
            title: 'Program settings',
            subtitle: 'Fill in the necessary information',
            tooltipCaption: 'From this section you can create all the necessary content to create a program'
        },
        finantial: {
            title: 'Finantial settings',
            subtitle: 'Accounts, Payout methods, Payout schedule',
            tooltipCaption: 'From this section you can manage everything related to your subproperty financial account',
            accountTab: 'Accounts',
            payoutMethodsTab: 'Payout Methods',
            payoutScheduleTab: 'Payout Schedule',
            othersTab: 'Others',
            accounts: {
                emptyAccountText: 'There\'s not connected account yet',
                emptyPersonText: 'There\'s not connected persons yet',
                emptyAccountButton: 'Add Connected Account',
                emptyPersonButton: 'Add Connected Persons',
                subtitle: {
                    connectedAccount: 'Connected account',
                    additionalQuestions: 'Additional questions',
                    connectedPersons: 'Connected persons',
                },
                payments: 'Payments',
                payouts: 'Payouts',
                deleteText: 'If you would like to delete a connected account or connected persons, please contact',
                disabledReason: {
                    'listed': 'Some of your account features are disabled because it might be on a prohibited persons or companies list (managed by Stripe).',
                    'under_review': 'Some of your account features are disabled because it is under review by Stripe.',
                    'other': 'Some of your account features are disabled because of an unknown reason. Please contact <a href="mailto:support@owqlo.com" target="_blank">support@owqlo.com</a>',
                    requirements: {
                        'past_due': 'Some of your account features are disabled because some requirements are already past due.',
                        'pending_verification': 'Some of your account features are disabled because verification is pending / ongoing.',
                    },
                    rejected: {
                        'fraud': 'Your account has been rejected due to suspected fraud or illegal activity. Please contact <a href="mailto:support@owqlo.com" target="_blank">support@owqlo.com</a>',
                        'terms_of_service': 'Your account has been rejected due to conflict with Stripe\'s Terms and Conditions. Please contact <a href="mailto:support@owqlo.com" target="_blank">support@owqlo.com</a>',
                        'listed': 'Your account has been rejected because it is on a third-party prohibited persons or companies list (managed by Stripe). Please contact <a href="mailto:support@owqlo.com" target="_blank">support@owqlo.com</a>',
                        'other': 'Your account has been rejected due to some unknown reason. Please contact <a href="mailto:support@owqlo.com" target="_blank">support@owqlo.com</a>',
                    },
                },
                requirements: {
                    titles: {
                        dueRequirements: 'Due requirements are:',
                        personRequirements: 'There are some requirements related to persons; please check below.',
                        currentlyVerifying: 'Currently verifying:',
                    },
                    relationship: {
                        owner: 'Add all owners (25% or more ownership)',
                        director: 'Add all directors',
                        representative: 'Add a representative',
                        account_opener: 'Add a representative',
                        title: 'Job title required',
                        executive: 'The representative must also be an executive or owner.',
                    },
                    address: {
                        city: 'Address: City required',
                        line1: 'Address: Line 1 required',
                        postal_code: 'Address: ZIP / Postal Code required',
                        state: 'Address: State required',
                    },
                    dob: {
                        day: 'Date of birth: Day required',
                        month: 'Date of birth: Month required',
                        year: 'Date of birth: Year required',
                    },
                    business_profile: {
                        mcc: 'Merchant Category Code (MCC) required',
                    },
                    verification: {
                        document: 'Identity documents required',
                        additional_document: 'Additional documents required',
                    },
                    company: {
                        verification: {
                            document: 'Company documents required',
                            additional_document: 'Additional company documents required',
                        },
                    },
                    email: 'Email required',
                    phone: 'Phone required',
                    ssn_last_4: 'SSN last four required',
                    external_account: 'Configure a Payout Method',
                },
            },
            questions: {
                relationship: {
                    director: 'Does anyone else serve as a director of {0}?',
                    owner: 'Does anyone else serve as an owner of {0}?',
                    executive: 'Does anyone else serve as an executive of {0}?',
                },
            },
            payoutMethods: {
                subtitle: {
                    bankAccount: 'Bank Accounts'
                },
                emptyText: 'There\'s not payout methods yet',
                emptyButton: 'Add Payout Method',
                default: 'Default',
                removeSuccess: 'Payout method remove successfully',
                setDefaultSuccess: 'Payout method saved successfully',
            },
            payoutSchedule: {
                cardInfo: 'Payments received by customers are stored in the <strong>wallet</strong> of the subproperty. To be able to transfer this money to a bank account, you can configure an <strong>automatic withdrawal</strong>, with <strong>the frequency</strong> that best suits your needs.',
                cardFrequency: {
                    title: 'Frequency',
                    fields: {
                        payout: 'Payout',
                    },
                    placeholders: {
                        manual: 'Manual',
                        automatic: 'Automatic',
                    }
                },
                fields: {
                    paymentsStatementDescriptor: 'Payment Descriptor',
                    payoutsScheduleDelayDays: 'Day',
                    payoutsScheduleInterval: 'Frequency',
                    payoutsScheduleMonthlyAnchor: 'Month day',
                    payoutsScheduleWeeklyAnchor: 'Week day',
                    payoutsStatementDescriptor: 'Payout Descriptor',
                    payoutsConfigured: 'Configured'
                },
                update: {
                    success: 'Payout frequency has been updated'
                }
            },


        },
        customize: {
            title: 'Customize subproperty',
            subtitle: 'URL configuration, App branding',
            tooltipCaption: 'From this section you can customize the URL of the web and all the contents of the App',
            configurationTab: 'Configuration',
            brandTab: 'Brand',
        },
    },

    seasonSettings: {
        title: 'Season settings',
        menu: 'Settings',
        league: {
            title: 'League settings',
            subtitle: 'Fill in the necessary information',
            tooltipCaption: 'From this section you can create all the necessary content to create a league',
            menu: 'Settings',
        },
    },

    home: {
        nav: {
            dashboard: 'Dashboard',
            general: 'General',
            management: 'Management',
            wallet: 'Wallet',
            finantial: 'Finantial',
            income: 'Income',
            adminConfiguration: 'Configuration',
            propertyConfiguration: 'Configuration',
            subpropertyConfiguration: 'Configuration',
        },
        menu: 'Home',
        charts: {
            day: 'Day',
            red: 'Red',
            green: 'Green',
            yellow: 'Yellow',
            grey: 'Grey',
            blue: 'Blue',
            sales: 'Sales',
            visitor: 'Visitors',
            months: {
                1: 'January',
                2: 'February',
                3: 'March',
                4: 'April',
                5: 'May',
                6: 'June',
                7: 'July',
            },
            eating: 'Eating',
            drinking: 'Drinking',
            sleeping: 'Sleeping',
            designing: 'Designing',
            coding: 'Coding',
            cycling: 'Cycling',
            running: 'Running',
            customer: 'Customer',
        },
    },

    errors: {
        backToHome: 'Back to home',
        403: `Sorry, you don't have access to this page`,
        404: 'Sorry, the page you visited does not exist',
        500: 'Sorry, the server is reporting an error',
        deleteConflict: 'Error on delete, contact with support@owqlo.com please.',
        forbidden: {
            message: 'Forbidden',
        },
        validation: {
            message: 'An error occurred',
        },
        defaultErrorMessage: 'Ops, an error occurred',
        defaultValidationErrorMessage: 'There are some errors in your form, please review them',
    },
    // See https://github.com/jquense/yup#using-a-custom-locale-dictionary
    /* eslint-disabled */
    validation: {
        mixed: {
            default: '${path} is invalid',
            required: 'Field required',
            requiredLabel: 'Field required',
            oneOf: '${path} must be one of the following values: ${values}',
            notOneOf: '${path} must not be one of the following values: ${values}',
            notType: ({ path, type }) => {
                return `${path} must be a ${type}`;
            }
        },
        string: {
            length: '${path} must be exactly ${length} characters',
            min: '${path} must be at least ${min} characters long',
            max: '${path} must be at most ${max} characters long',
            matches: '${path} must match the following: "${regex}"',
            numeric: '${path} must only contain numbers',
            email: '${path} must be a valid email',
            url: '${path} must be a valid URL',
            trim: '${path} must be a trimmed string',
            lowercase: '${path} must be a lowercase string',
            uppercase: '${path} must be a upper case string',
            selected: 'Field required',
        },
        number: {
            min: '${path} must be greater than or equal to ${min}',
            max: '${path} must be less than or equal to ${max}',
            lessThan: '${path} must be less than ${less}',
            moreThan: '${path} must be greater than ${more}',
            notEqual: '${path} must be not equal to ${notEqual}',
            positive: '${path} must be a positive number',
            negative: '${path} must be a negative number',
            integer: '${path} must be an integer',
            invalid: '${path} must be a number',
        },
        date: {
            min: '${path} field must be later than ${min}',
            max: '${path} field must be at earlier than ${max}',
            mustBePast: 'Date must be in the past',
            minAge: 'Minimum age required (${age})',
        },
        boolean: {},
        object: {
            noUnknown: '${path} field cannot have keys not specified in the object shape',
        },
        array: {
            min: '${path} field must have at least ${min} items',
            max: '${path} field must have less than or equal to ${max} items',
        },
    },
    /* eslint-disabled */
    fileUploader: {
        upload: 'Upload',
        uploadFile: 'Upload a file',
        image: 'You must upload an image',
        size: 'File is too large. Maximum allowed size is for this files is {0}',
        formats: `File type is not accepted. This field only accepts {0} file types`,
        maxReached: 'You have reached the maximum Number of files ({0})',
        exceed: 'You can only upload 1 more file',
        exceedPlural: 'You can only upload {0} more files',
    },
    importer: {
        line: 'Line',
        status: 'Status',
        pending: 'Pending',
        imported: 'Imported',
        error: 'Error',
        total: `{0} imported, {1} pending and {2} with error`,
        importedMessage: `Processed {0} of {1}.`,
        noNavigateAwayMessage: 'Do not navigate away from this page or import will be stopped.',
        completed: {
            success: 'Import completed. All rows were successfully imported.',
            someErrors: 'Processing completed, but some rows were unable to be imported.',
            allErrors: 'Import failed. There are no valid rows.',
        },
        form: {
            downloadTemplate: 'Download the template',
            hint: 'Click or drag the file to this area to continue',
        },
        list: {
            discardConfirm: 'Are you sure? Non-imported data will be lost.',
        },
        errors: {
            invalidFileEmpty: 'The file is empty',
            invalidFileExcel: 'Only excel (.xlsx) files are allowed',
            invalidFileUpload: 'Invalid file. Make sure you are using the last version of the template.',
            importHashRequired: 'Import hash is required',
            importHashExistent: 'Data has already been imported',
        },
    },

    autocomplete: {
        loading: 'Loading...',
    },

    imagesViewer: {
        noImage: 'No image',
    },

    firebaseErrors: {
        'auth/user-disabled': 'Your account is disabled',
        'auth/user-not-found': `Sorry, we don't recognize your credentials`,
        'auth/wrong-password': `Sorry, we don't recognize your credentials`,
        'auth/weak-password': 'This password is too weak',
        'auth/email-already-in-use': 'Email is already in use',
        'auth/invalid-email': 'Please provide an valid email',
        'auth/account-exists-with-different-credential': 'Email is already in use for a different authentication method.',
        'auth/credential-already-in-use': 'Credentials are already in use',
        'auth/too-many-requests': 'Too many unsuccessful log in attempts. Try again in a few moments',
    },

    stripeErrorCodes: {
        'default': 'The value provided is invalid.',
        // https://stripe.com/docs/error-codes
        'account_country_invalid_address': 'The country of the business address provided does not match the country of the account. Businesses must be located in the same country as the account.',
        'email_invalid': 'The email provided is invalid.',
        'postal_code_invalid': 'The postal code provided is invalid.',
        'state_unsupported': 'The state provided is unsupported.',
        'tax_id_invalid': 'The Tax ID provided is invalid.',
        'url_invalid': 'The URL provided is invalid.',
        'account_number_invalid': 'The account number provided is invalid.',
        'routing_number_invalid': 'The routing number provided is invalid.',
    },

    teamRegistrationSite: {
        home: {
            welcome: 'Welcome to the registration form for the Madcup Tournament',
            acceptTermsAndPrivacy: 'I accept the <a href="https://www.owqlo.biz/terms-and-conditions" target="_blank">terms and conditions</a> and <a href="https://owqlo.com/privacy-policy/" target="_blank">privacy policy</a>',
            acceptOrganizationPrivacy: 'I accept the <a href="https://www.madcup.es/configwp/index.php/politica-de-privacidad/" target="_blank">privacy policy</a> of MadCup'
        },
        form: {
            step1: {
                title: 'Club',
                subtitles: {
                    homeKitColor: 'Home kit',
                    awayKitColor: 'Away kit',
                },
            },
            step2: {
                title: 'Address',
            },
            step3: {
                title: 'Person in charge',
                subtitles: {
                    personInCharge: 'Person in charge'
                },
                buttons: {
                    addMore: 'Add another person in charge',
                },
                confirm: 'Are you sure you want to remove this person in charge?',
            },
            step4: {
                title: 'Teams',
                titleAlt: 'Team categories',
                labels: {
                    team: 'Team',
                },
                subtitles: {
                    category: 'Team category'
                },
                buttons: {
                    addTeam: 'Add team',
                    addMore: 'Register teams to another category',
                },
                confirm: 'Are you sure you want to remove this category?',
            },
            step5: {
                title: 'Confirmation',
                subtitles: {
                    clubInformation: 'Club information',
                    clubAccommodation: 'Accommodation',
                    clubKitHome: 'Home kit',
                    clubKitAway: 'Away kit',
                    clubJerseyType: 'Type of jersey:',
                    clubJerseyColor: 'Color of jersey:',
                    clubPantsColor: 'Color of pants:',
                },
                categoryGender: {
                    male: 'Masculine',
                    female: 'Feminine',
                },
            },
            step6: {
                title: 'Congratulations!',
                subtitle: 'You have registered correctly',
                text: {
                    first: '{0}, We inform you that the registration for team {1} has been successfully completed and approval is pending on the part of subproperty {2}.',
                    second: 'Once your registration has been approved, you will receive a confirmation email.',
                },
            },
            mandatoryFields: 'Mandatory fields',
            validation: {
                allColorsRequired: 'All colors are mandatory for jersey and pants',
                selectJerseyTypeMessage: 'Select jersey type and colors',
            },
        },
        registration: 'Registration',
        footer: 'If you have any problem, please contact',
    },
};

module.exports = en;